class CodeTextEnum {
  constructor(value, code, text) {
    this.code = code
    this.value = value
    this.text = text
  }
}
// 提案計画進捗状態
const proposalProgressStatusEnum = Object.freeze({
  enum_300: new CodeTextEnum('300', 'enum_300', '提案計画活動中'),
  enum_330: new CodeTextEnum('330', 'enum_330', '提案計画未採用'),
  enum_320: new CodeTextEnum('320', 'enum_320', '受注'),
  enum_340: new CodeTextEnum('340', 'enum_340', '受注キャンセル'),
  enum_400: new CodeTextEnum('400', 'enum_400', '納品完了'),
})
// 見積ステータス
const estimateStatusEnum = Object.freeze({
  enum_580: new CodeTextEnum('580', 'enum_580', '見積登録中・見積変更中'),
  enum_500: new CodeTextEnum('500', 'enum_500', '原価承認待ち'),
  enum_501: new CodeTextEnum('501', 'enum_501', '原価承認保留中'),
  enum_502: new CodeTextEnum('502', 'enum_502', '原価否決'),
  enum_520: new CodeTextEnum('520', 'enum_520', '原価承認済'),
  enum_530: new CodeTextEnum('530', 'enum_530', '原価再登録中'),
  enum_540: new CodeTextEnum('540', 'enum_540', '原価再登録承認待ち　'),
  enum_541: new CodeTextEnum('541', 'enum_541', '原価再登録承認保留中'),
  enum_542: new CodeTextEnum('542', 'enum_542', '原価再登録否決'),
  enum_600: new CodeTextEnum('600', 'enum_600', '見積承認待ち'),
  enum_601: new CodeTextEnum('601', 'enum_601', '見積承認保留中'),
  enum_602: new CodeTextEnum('602', 'enum_602', '見積否決'),
  enum_610: new CodeTextEnum('610', 'enum_610', '原価見積承認待ち'),
  enum_611: new CodeTextEnum('611', 'enum_611', '原価見積承認保留中'),
  enum_612: new CodeTextEnum('612', 'enum_612', '原価見積否決'),
  enum_620: new CodeTextEnum('620', 'enum_620', '見積承認済'),
  enum_690: new CodeTextEnum('690', 'enum_690', '見積取消'),
})
// 受注状態区分
const acceptOrderStatusClassEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '提案前'),
  enum_1: new CodeTextEnum('1', 'enum_1', '提案'),
  enum_2: new CodeTextEnum('2', 'enum_2', '受注前'),
  enum_3: new CodeTextEnum('3', 'enum_3', '受注'),
})
// 受注ステータス
const acceptOrderStatusEnum = Object.freeze({
  enum_300: new CodeTextEnum('300', 'enum_300', '提案計画活動中'),
  enum_330: new CodeTextEnum('330', 'enum_330', '提案計画未採用・受注取消'),
  enum_110: new CodeTextEnum('110', 'enum_110', '受注登録中'),
  enum_120: new CodeTextEnum('120', 'enum_120', '受注変更中'),
  enum_140: new CodeTextEnum('140', 'enum_140', '受注ｷｬﾝｾﾙ中'),
  enum_210: new CodeTextEnum('210', 'enum_210', '受注承認待ち'),
  enum_211: new CodeTextEnum('211', 'enum_211', '受注承認保留中'),
  enum_212: new CodeTextEnum('212', 'enum_212', '受注否決'),
  enum_220: new CodeTextEnum('220', 'enum_220', '受注変更承認待ち'),
  enum_221: new CodeTextEnum('221', 'enum_221', '受注変更保留中'),
  enum_222: new CodeTextEnum('222', 'enum_222', '受注変更否決'),
  enum_240: new CodeTextEnum('240', 'enum_240', '受注ｷｬﾝｾﾙ承認待ち'),
  enum_241: new CodeTextEnum('241', 'enum_241', '受注ｷｬﾝｾﾙ保留中'),
  enum_242: new CodeTextEnum('242', 'enum_242', '受注ｷｬﾝｾﾙ否決'),
  enum_320: new CodeTextEnum('320', 'enum_320', '受注'),
  enum_340: new CodeTextEnum('340', 'enum_340', '受注ｷｬﾝｾﾙ'),
  enum_400: new CodeTextEnum('400', 'enum_400', '納品完了'),
})
// 発注ステータス
const purchaseOrderStatusEnum = Object.freeze({
  enum_700: new CodeTextEnum('700', 'enum_700', '発注登録中'),
  enum_710: new CodeTextEnum('710', 'enum_710', '発注変更中'),
  enum_720: new CodeTextEnum('720', 'enum_720', '発注キャンセル中'),
  enum_800: new CodeTextEnum('800', 'enum_800', '発注登録承認待ち '),
  enum_801: new CodeTextEnum('801', 'enum_801', '発注登録保留中'),
  enum_802: new CodeTextEnum('802', 'enum_802', '発注登録否決'),
  enum_810: new CodeTextEnum('810', 'enum_810', '発注変更承認待ち'),
  enum_811: new CodeTextEnum('811', 'enum_811', '発注変更保留中'),
  enum_812: new CodeTextEnum('812', 'enum_812', '発注変更否決'),
  enum_820: new CodeTextEnum('820', 'enum_820', '発注キャンセル承認待ち'),
  enum_821: new CodeTextEnum('821', 'enum_821', '発注キャンセル保留中'),
  enum_822: new CodeTextEnum('822', 'enum_822', '発注キャンセル否決'),
  enum_900: new CodeTextEnum('900', 'enum_900', '発注'),
  enum_920: new CodeTextEnum('920', 'enum_920', '発注キャンセル'),
  enum_730: new CodeTextEnum('730', 'enum_730', '発注廃止'),
})
// 請求書敬称区分
const billTitleClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '御中'),
  enum_2: new CodeTextEnum('2', 'enum_2', '様'),
})
// 提案対応レベル
const demandResponseLevelEnum = Object.freeze({
  enum_S: new CodeTextEnum('S', 'enum_S', '危険・法令違反'),
  enum_A: new CodeTextEnum('A', 'enum_A', '１年以内対応'),
  enum_B: new CodeTextEnum('B', 'enum_B', '2～3年以内対応'),
  enum_C: new CodeTextEnum('C', 'enum_C', '4～5年以内対応'),
  enum_D: new CodeTextEnum('D', 'enum_D', '提案事項'),
  enum_P: new CodeTextEnum('P', 'enum_P', 'ﾍﾟﾝﾃﾞｨﾝｸﾞ'),
})
// 取引先区分
const customerClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '法人'),
  enum_2: new CodeTextEnum('2', 'enum_2', 'グループ'),
  enum_3: new CodeTextEnum('3', 'enum_3', '組合'),
  enum_4: new CodeTextEnum('4', 'enum_4', '個人'),
})
// 請求書出力区分(受注)
const acceptOrderInvoiceOutputClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '請求書を金額変更時に出力'),
  enum_2: new CodeTextEnum('2', 'enum_2', '請求書を発行(経理から直送)'),
  enum_3: new CodeTextEnum('3', 'enum_3', '発行不要'),
  enum_4: new CodeTextEnum('4', 'enum_4', '請求書を発行(拠点へ返送)'),
})
// 請求支払区分
const billPayClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '請求'),
  enum_2: new CodeTextEnum('2', 'enum_2', '支払'),
  enum_3: new CodeTextEnum('3', 'enum_3', '請求兼支払'),
  enum_4: new CodeTextEnum('4', 'enum_4', '点検拠点登録用'),
  enum_5: new CodeTextEnum('5', 'enum_5', '内製発注先'),
})
// 分類
const classificationEnum = Object.freeze({
  enum_01: new CodeTextEnum('01', 'enum_01', '受託新規'),
  enum_02: new CodeTextEnum('02', 'enum_02', '受託改定'),
  enum_90: new CodeTextEnum('90', 'enum_90', 'その他'),
})
// 拠点区分
const baseClassEnum = Object.freeze({
  enum_E: new CodeTextEnum('E', 'enum_E', '関東'),
  enum_W: new CodeTextEnum('W', 'enum_W', '関西'),
})
// 引当完了区分
const depositFinishClassEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '未入金'),
  enum_1: new CodeTextEnum('1', 'enum_1', '一部入金'),
  enum_2: new CodeTextEnum('2', 'enum_2', '満額入金'),
})
// 工期区分
const constructionClassEnum = Object.freeze({
  enum_A: new CodeTextEnum('A', 'enum_A', '開始日～終了日'),
  enum_B: new CodeTextEnum('B', 'enum_B', '契約の日から3ヶ月'),
  enum_C: new CodeTextEnum('C', 'enum_C', '契約の日から6ヶ月'),
  enum_D: new CodeTextEnum('D', 'enum_D', '発注より○ヶ月着工、○週間で竣工'),
  enum_E: new CodeTextEnum('E', 'enum_E', '契約の日から10ヶ月'),
  enum_F: new CodeTextEnum('F', 'enum_F', '診断日から○ヶ月'),
  enum_G: new CodeTextEnum('G', 'enum_G', '契約の日から1年間'),
})
// 作成判断区分
const createJudgeClassEnum = Object.freeze({
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '直接提案計画'),
  enum_1: new CodeTextEnum('1', 'enum_1', '手動'),
  enum_2: new CodeTextEnum('2', 'enum_2', '自動'),
  enum_3: new CodeTextEnum('3', 'enum_3', '移行'),
  enum_4: new CodeTextEnum('4', 'enum_4', 'インポート（提案計画）'),
  enum_5: new CodeTextEnum('5', 'enum_5', '直接受注'),
  enum_6: new CodeTextEnum('6', 'enum_6', 'インポート（直接受注）'),
})
// 作成状態フラグ
const createStateFlgEnum = Object.freeze({
  enum_10: new CodeTextEnum('10', 'enum_10', '提案計画登録中'),
  enum_13: new CodeTextEnum('13', 'enum_13', '提案計画変更中'),
  enum_30: new CodeTextEnum('30', 'enum_30', '提案計画活動中'),
  enum_33: new CodeTextEnum('33', 'enum_33', '提案計画未採用'),
  enum_32: new CodeTextEnum('32', 'enum_32', '受注'),
  enum_34: new CodeTextEnum('34', 'enum_34', '受注キャンセル'),
  enum_40: new CodeTextEnum('40', 'enum_40', '納品完了'),
})
// 工事内容区分
const workDetailClassEnum = Object.freeze({
  enum_A: new CodeTextEnum(
    'A',
    'enum_A',
    '別途受注者から交付された見積書のとおりとします。'
  ),
  enum_B: new CodeTextEnum('B', 'enum_B', '添付の見積書のとおりとします。'),
  enum_C: new CodeTextEnum('C', 'enum_C', '明細のとおりとします。'),
})
// 預金種別
const depositTypeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '普通預金'),
  enum_2: new CodeTextEnum('2', 'enum_2', '当座預金'),
  enum_9: new CodeTextEnum('9', 'enum_9', 'その他'),
})
// 納期区分
const limitClassEnum = Object.freeze({
  enum_A: new CodeTextEnum('A', 'enum_A', '契約の日から3ヶ月'),
  enum_B: new CodeTextEnum('B', 'enum_B', '契約の日から6ヶ月'),
  enum_C: new CodeTextEnum('C', 'enum_C', '日付指定'),
  enum_D: new CodeTextEnum('D', 'enum_D', '契約の日から1年'),
})
// 採用区分
const adoptFlagEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '採用'),
  enum_9: new CodeTextEnum('9', 'enum_9', '不採用'),
})
// 見積レベル
const estimateLevelEnum = Object.freeze({
  enum_A: new CodeTextEnum('A', 'enum_A', 'A'),
  enum_B: new CodeTextEnum('B', 'enum_B', 'B'),
  enum_C: new CodeTextEnum('C', 'enum_C', 'C'),
  enum_P: new CodeTextEnum('P', 'enum_P', 'P'),
  enum_N: new CodeTextEnum('N', 'enum_N', 'N'),
})
// 見積無区分
const noEstimateFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum(
    '1',
    'enum_1',
    '見積無し（お客様発注書・納品書登録）'
  ),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '見積あり'),
})
// 見積書様式区分
const estimateStyleClassEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '見積無し'),
  enum_1: new CodeTextEnum('1', 'enum_1', '単票タイプ'),
  enum_2: new CodeTextEnum('2', 'enum_2', '内訳明細タイプ'),
  enum_3: new CodeTextEnum('3', 'enum_3', '元請工事タイプ'),
  enum_4: new CodeTextEnum('4', 'enum_4', '調査・診断業務タイプ'),
  enum_5: new CodeTextEnum('5', 'enum_5', 'コンサル業務タイプ'),
  enum_6: new CodeTextEnum('6', 'enum_6', '監理業務タイプ'),
  enum_7: new CodeTextEnum('7', 'enum_7', '検査業務タイプ'),
  enum_8: new CodeTextEnum('8', 'enum_8', 'タイルタイプ'),
  enum_A: new CodeTextEnum('A', 'enum_A', '単票_建設業法対応'),
  enum_B: new CodeTextEnum('B', 'enum_B', '明細_建設業法対応'),
  enum_C: new CodeTextEnum('C', 'enum_C', '単票_建設業法先方'),
  enum_D: new CodeTextEnum('D', 'enum_D', '明細_建設業法先方'),
  enum_E: new CodeTextEnum('E', 'enum_E', '災害マニュアル'),
})
// 設備分類
const facilityClassEnum = Object.freeze({
  enum_11: new CodeTextEnum('11', 'enum_11', '(点検)総合設備点検'),
  enum_12: new CodeTextEnum('12', 'enum_12', '(緊急)総合設備点検'),
  enum_19: new CodeTextEnum('19', 'enum_19', '(その他)総合設備点検'),
  enum_21: new CodeTextEnum('21', 'enum_21', '(点検)消防設備点検'),
  enum_22: new CodeTextEnum('22', 'enum_22', '(緊急)消防設備点検'),
  enum_29: new CodeTextEnum('29', 'enum_29', '(その他)消防設備点検'),
  enum_31: new CodeTextEnum('31', 'enum_31', '(点検)エレベータ設備'),
  enum_32: new CodeTextEnum('32', 'enum_32', '(緊急)エレベータ設備'),
  enum_39: new CodeTextEnum('39', 'enum_39', '(その他)エレベータ設備'),
  enum_41: new CodeTextEnum('41', 'enum_41', '(点検)機械式駐車装置'),
  enum_42: new CodeTextEnum('42', 'enum_42', '(緊急)機械式駐車装置'),
  enum_49: new CodeTextEnum('49', 'enum_49', '(その他)機械式駐車装置'),
  enum_51: new CodeTextEnum('51', 'enum_51', '(点検)浄化槽設備'),
  enum_52: new CodeTextEnum('52', 'enum_52', '(緊急)浄化槽設備'),
  enum_59: new CodeTextEnum('59', 'enum_59', '(その他)浄化槽設備'),
  enum_61: new CodeTextEnum('61', 'enum_61', '(点検)防犯カメラ'),
  enum_62: new CodeTextEnum('62', 'enum_62', '(緊急)防犯カメラ'),
  enum_69: new CodeTextEnum('69', 'enum_69', '(その他)防犯カメラ'),
  enum_70: new CodeTextEnum(
    '70',
    'enum_70',
    '1．計画修繕(長計にある工事又は役務)'
  ),
  enum_71: new CodeTextEnum(
    '71',
    'enum_71',
    '2．改良工事(長計にない工事又は役務)'
  ),
  enum_72: new CodeTextEnum('72', 'enum_72', '3．点検 NG'),
  enum_73: new CodeTextEnum(
    '73',
    'enum_73',
    '4．緊急対応(LN24手配など緊急対応案件全般)'
  ),
  enum_74: new CodeTextEnum(
    '74',
    'enum_74',
    '5．その他(1～4に該当しない工事又は役務、小修繕等)'
  ),
  enum_88: new CodeTextEnum('88', 'enum_88', '事後'),
  enum_91: new CodeTextEnum('91', 'enum_91', '(点検)その他'),
  enum_92: new CodeTextEnum('92', 'enum_92', '(緊急)その他'),
  enum_99: new CodeTextEnum('99', 'enum_99', '(その他)その他'),
})
// 発注書出力区分
const purchaseOrderOutputClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '連絡書or発注書Ａ'),
  enum_2: new CodeTextEnum('2', 'enum_2', '役務発注書'),
  enum_5: new CodeTextEnum('5', 'enum_5', '役務発注書          ＋納品報告'),
  enum_6: new CodeTextEnum('6', 'enum_6', '役務明細　　　　＋納品報告'),
  enum_E: new CodeTextEnum('E', 'enum_E', '建設業法'),
  enum_F: new CodeTextEnum('F', 'enum_F', '建設業法             ＋納品報告'),
  enum_G: new CodeTextEnum('G', 'enum_G', '建業明細'),
  enum_H: new CodeTextEnum('H', 'enum_H', '建業明細             ＋納品報告'),
  enum_J: new CodeTextEnum('J', 'enum_J', '専門                   ＋納品報告'),
  enum_L: new CodeTextEnum('L', 'enum_L', '工事部役務・診断＋納品報告'),
  enum_N: new CodeTextEnum('N', 'enum_N', 'タイル                ＋納品報告'),
  enum_P: new CodeTextEnum('P', 'enum_P', '移転・物販'),
  enum_U: new CodeTextEnum('U', 'enum_U', '建設業法並記'),
  enum_V: new CodeTextEnum('V', 'enum_V', '建設業法並記      ＋納品報告'),
  enum_W: new CodeTextEnum('W', 'enum_W', '建業明細並記'),
  enum_X: new CodeTextEnum('X', 'enum_X', '建業明細並記      ＋納品報告'),
  enum_Y: new CodeTextEnum('Y', 'enum_Y', 'EVリニューアル  ＋納品報告'),
  enum_9: new CodeTextEnum('9', 'enum_9', '発注書別途作成'),
})
// 発生元識別区分
const originIdentClassEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '販売管理'),
  enum_1: new CodeTextEnum('1', 'enum_1', '伝票エントリー'),
  enum_2: new CodeTextEnum('2', 'enum_2', '人事システム'),
  enum_3: new CodeTextEnum('3', 'enum_3', 'SuperStream'),
  enum_4: new CodeTextEnum('4', 'enum_4', '人件費原価'),
  enum_9: new CodeTextEnum('9', 'enum_9', 'その他'),
})
// 産廃取扱い区分
const industryTrashHandlingFlgEnum = Object.freeze({
  enum_A: new CodeTextEnum(
    'A',
    'enum_A',
    '別途指示書に基づき、発注者の指定場所へ運搬'
  ),
  enum_B: new CodeTextEnum('B', 'enum_B', '現地指定場所へ保管'),
  enum_Z: new CodeTextEnum('Z', 'enum_Z', 'その他(任意入力)'),
})
// お知らせ区分
const infoClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '掲示'),
  enum_2: new CodeTextEnum('2', 'enum_2', 'ビラのポスティング'),
  enum_3: new CodeTextEnum('3', 'enum_3', 'しない'),
  enum_4: new CodeTextEnum('4', 'enum_4', '掲示・ビラのポスティング'),
})
// 業務形態
const consignmentWorkClassEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '建設工事'),
  enum_1: new CodeTextEnum('1', 'enum_1', '役務'),
  enum_2: new CodeTextEnum('2', 'enum_2', '受託'),
})
// 受注区分ｃｄ
const acceptOrderClassCdEnum = Object.freeze({
  enum_A: new CodeTextEnum('A', 'enum_A', '当期受注&当期全額売上計上'),
  enum_B: new CodeTextEnum('B', 'enum_B', '当期一部売上計上'),
  enum_C: new CodeTextEnum('C', 'enum_C', '受注繰越（売上計上なし）'),
  enum_D: new CodeTextEnum('D', 'enum_D', 'Bからの変化のみ　'),
})
// ｋｅｙ種別
const keyClassEnum = Object.freeze({
  enum_HB: new CodeTextEnum('HB', 'enum_HB', '被請求書作成'),
  enum_LB: new CodeTextEnum('LB', 'enum_LB', '総合設備リスト'),
  enum_RJ: new CodeTextEnum('RJ', 'enum_RJ', '引当受注ＮＯ'),
  enum_RR: new CodeTextEnum('RR', 'enum_RR', '引当入金ＮＯ'),
  enum_RB: new CodeTextEnum('RB', 'enum_RB', '引当請求ＮＯ'),
  enum_MT: new CodeTextEnum('MT', 'enum_MT', '取引先マスタ'),
})
// 金額ゼロ種別
const priceZeroClassEnum = Object.freeze({
  enum_S: new CodeTextEnum('S', 'enum_S', 'サービス(無償提供)'),
  enum_C: new CodeTextEnum('C', 'enum_C', '受注後のキャンセル'),
  enum_T: new CodeTextEnum('T', 'enum_T', '提案計画・受注の取消'),
  enum_G: new CodeTextEnum('G', 'enum_G', '共通原価集計用'),
})
// 内外区分
const inOutClassEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '内製'),
  enum_1: new CodeTextEnum('1', 'enum_1', '外製'),
  enum_2: new CodeTextEnum('2', 'enum_2', '混在'),
})
// 要否区分
const necessaryFlagEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '要'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '不要'),
})
// 不要フラグ
const unnecessaryFlagEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '不要'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '要'),
})
// 真偽区分
const boolFlagEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '真'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '偽'),
})
// 有無区分
const existFlagEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '有'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '無'),
})
// 有無区分2
const existFlag2Enum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', 'あり'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', 'なし'),
})
// 発注作成区分
const generationClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '自動生成'),
  enum_0: new CodeTextEnum('0', 'enum_0', '通常'),
})
// 納品後請求フラグ
const afterDeliveryBillFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '納品後請求'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '納品前請求'),
})
// 印鑑区分
const stampClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '角印'),
  enum_2: new CodeTextEnum('2', 'enum_2', '丸印'),
})
// 消費税計算区分
const consumptionTaxCalClassEnum = Object.freeze({
  enum_1: new CodeTextEnum(
    '1',
    'enum_1',
    '明細金額での消費税計算(以外のときは、従来どおりの合計金額での消費税計算となりまする)'
  ),
})
// 発注期間区分
const periodClassEnum = Object.freeze({
  enum_A: new CodeTextEnum('A', 'enum_A', '開始日 ～ 終了日'),
  enum_B: new CodeTextEnum('B', 'enum_B', '契約の日から６ヶ月'),
  enum_C: new CodeTextEnum('C', 'enum_C', '契約の日から３ヶ月'),
  enum_Z: new CodeTextEnum('Z', 'enum_Z', 'その他'),
})
// 作業予実区分
const planAndResultClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '受注'),
  enum_2: new CodeTextEnum('2', 'enum_2', 'お客様'),
})
// 支払条件
const payConditionEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '完成確認月月末締翌月20日支払'),
  enum_2: new CodeTextEnum('2', 'enum_2', '完了報告書受領月月末締翌月末日支払'),
  enum_3: new CodeTextEnum(
    '3',
    'enum_3',
    '完了報告書受領月月末締翌々月10日支払'
  ),
  enum_4: new CodeTextEnum('4', 'enum_4', '特例'),
  enum_5: new CodeTextEnum('5', 'enum_5', '分割支払い'),
  enum_6: new CodeTextEnum('6', 'enum_6', '支払先から設定'),
})
// 工事記録簿ｽﾃｰﾀｽ(基本)
const constructionRecordStatusBaseEnum = Object.freeze({
  enum_A01: new CodeTextEnum('A01', 'enum_A01', '提案計画登録(ｵﾝﾗｲﾝ)済み'),
  enum_A02: new CodeTextEnum('A02', 'enum_A02', '提案計画登録(ｲﾝﾎﾟｰﾄ)済み'),
  enum_A03: new CodeTextEnum('A03', 'enum_A03', '受注確認登録確認依頼中'),
  enum_A04: new CodeTextEnum('A04', 'enum_A04', '受注確認登録中'),
  enum_A05: new CodeTextEnum('A05', 'enum_A05', '見積採用・受注登録依頼中'),
  enum_A06: new CodeTextEnum('A06', 'enum_A06', '見積採用・受注登録中'),
  enum_A07: new CodeTextEnum('A07', 'enum_A07', '受注確認保留中'),
  enum_A90: new CodeTextEnum('A90', 'enum_A90', '工事記録簿活動中'),
})
// 工事記録簿ｽﾃｰﾀｽ(受注締結)
const constructionRecordStatusAcceptingOrderAlliaEnum = Object.freeze({
  enum_A10: new CodeTextEnum('A10', 'enum_A10', '受注締結未登録'),
  enum_A11: new CodeTextEnum('A11', 'enum_A11', '受注締結登録中'),
  enum_A12: new CodeTextEnum('A12', 'enum_A12', '受注締結承認待ち'),
  enum_A13: new CodeTextEnum('A13', 'enum_A13', '受注締結済'),
  enum_A14: new CodeTextEnum('A14', 'enum_A14', '受注締結保留中'),
})
// 工事記録簿ｽﾃｰﾀｽ(組合完了確認書)
const constructionRecordStatusUniFinishAckEnum = Object.freeze({
  enum_A20: new CodeTextEnum('A20', 'enum_A20', '組合完了確認書未登録'),
  enum_A21: new CodeTextEnum('A21', 'enum_A21', '組合完了確認書登録中'),
  enum_A22: new CodeTextEnum('A22', 'enum_A22', '組合完了確認書承認待ち'),
  enum_A23: new CodeTextEnum('A23', 'enum_A23', '組合完了確認書確認済'),
  enum_A24: new CodeTextEnum('A24', 'enum_A24', '組合完了確認書保留中'),
})
// 工事記録簿ｽﾃｰﾀｽ(完了報告書)
const constructionRecordStatusFinishReportEnum = Object.freeze({
  enum_A30: new CodeTextEnum('A30', 'enum_A30', '完了報告書未登録'),
  enum_A31: new CodeTextEnum('A31', 'enum_A31', '完了報告書登録中'),
  enum_A32: new CodeTextEnum('A32', 'enum_A32', '完了報告書承認待ち'),
  enum_A33: new CodeTextEnum('A33', 'enum_A33', '完了報告書済'),
  enum_A34: new CodeTextEnum('A34', 'enum_A34', '完了報告書保留中'),
})
// 工事記録簿ｽﾃｰﾀｽ(下請締結)
const constructionRecordStatusSubconAlliaEnum = Object.freeze({
  enum_D10: new CodeTextEnum('D10', 'enum_D10', '下請締結未登録'),
  enum_D11: new CodeTextEnum('D11', 'enum_D11', '下請締結登録中'),
  enum_D12: new CodeTextEnum('D12', 'enum_D12', '下請締結承認待ち'),
  enum_D13: new CodeTextEnum('D13', 'enum_D13', '下請締結済'),
  enum_D14: new CodeTextEnum('D14', 'enum_D14', '下請締結保留中'),
})
// 工事記録簿ｽﾃｰﾀｽ(下請完了)
const constructionRecordStatusSubconFinishEnum = Object.freeze({
  enum_D20: new CodeTextEnum('D20', 'enum_D20', '下請完了書類未登録'),
  enum_D21: new CodeTextEnum('D21', 'enum_D21', '下請完了書類登録中'),
  enum_D22: new CodeTextEnum('D22', 'enum_D22', '下請完了書類承認待ち'),
  enum_D23: new CodeTextEnum('D23', 'enum_D23', '下請完了書類済'),
  enum_D24: new CodeTextEnum('D24', 'enum_D24', '下請完了書類保留中'),
})
// 発注保証書区分
const purchaseOrderWarrantyClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '保証書あり'),
  enum_2: new CodeTextEnum('2', 'enum_2', '保証書なし'),
  enum_3: new CodeTextEnum('3', 'enum_3', '保証書未着'),
})
// 工事記録簿ステータス（受注）
const constructionRecordStatusAcceptingOrderEnum = Object.freeze({
  enum_A03: new CodeTextEnum('A03', 'enum_A03', '受注確認登録確認依頼中'),
  enum_A07: new CodeTextEnum('A07', 'enum_A07', '受注確認保留中'),
  enum_A12: new CodeTextEnum('A12', 'enum_A12', '受注締結承認待ち'),
  enum_A14: new CodeTextEnum('A14', 'enum_A14', '受注締結保留中'),
  enum_A22: new CodeTextEnum('A22', 'enum_A22', '組合完了確認書承認待ち'),
  enum_A24: new CodeTextEnum('A24', 'enum_A24', '組合完了確認書保留中'),
  enum_A32: new CodeTextEnum('A32', 'enum_A32', '完了報告書承認待ち'),
  enum_A34: new CodeTextEnum('A34', 'enum_A34', '完了報告書保留中'),
})
// 工事記録簿ステータス（発注）
const constructionRecordStatusPurchaseOrderEnum = Object.freeze({
  enum_D12: new CodeTextEnum('D12', 'enum_D12', '下請締結承認待ち'),
  enum_D14: new CodeTextEnum('D14', 'enum_D14', '下請締結保留中'),
  enum_D22: new CodeTextEnum('D22', 'enum_D22', '下請完了書類承認待ち'),
  enum_D24: new CodeTextEnum('D24', 'enum_D24', '下請完了書類保留中'),
})
// 案件タイプ
const demandTypeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', 'SC1'),
  enum_2: new CodeTextEnum('2', 'enum_2', 'SC2'),
  enum_3: new CodeTextEnum('3', 'enum_3', 'SC3'),
  enum_4: new CodeTextEnum('4', 'enum_4', 'RC'),
  enum_5: new CodeTextEnum('5', 'enum_5', 'RCS'),
  enum_6: new CodeTextEnum('6', 'enum_6', 'RCS（スポット）'),
  enum_7: new CodeTextEnum('7', 'enum_7', 'RCS（業務委託）'),
  enum_x: new CodeTextEnum('x', 'enum_x', 'その他'),
})
// 印刷住所ｆ
const printAddressFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '発注者住所を「西新宿」にて印字'),
  enum_2: new CodeTextEnum('2', 'enum_2', '発注者住所を「新大阪」にて印字'),
})
// 被請求書発行フラグ
const printFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '作成済み'),
  enum_2: new CodeTextEnum('2', 'enum_2', '発行完了'),
  enum_3: new CodeTextEnum('3', 'enum_3', '原価計上済み'),
  enum_4: new CodeTextEnum('4', 'enum_4', '再発行完了'),
})
// 案件状況
const demandPhaseEnum = Object.freeze({
  enum_10: new CodeTextEnum('10', 'enum_10', '提案計画 '),
  enum_20: new CodeTextEnum('20', 'enum_20', '見積協力依頼'),
  enum_30: new CodeTextEnum('30', 'enum_30', '見積 '),
  enum_40: new CodeTextEnum('40', 'enum_40', '受注 '),
  enum_50: new CodeTextEnum('50', 'enum_50', '発注 '),
  enum_70: new CodeTextEnum('70', 'enum_70', '納品'),
  enum_80: new CodeTextEnum('80', 'enum_80', '案件終了'),
  enum_90: new CodeTextEnum('90', 'enum_90', '案件中止'),
})
// 実施周期
const implementationCycleEnum = Object.freeze({
  enum_01: new CodeTextEnum('01', 'enum_01', '1年'),
  enum_02: new CodeTextEnum('02', 'enum_02', '2年　'),
  enum_03: new CodeTextEnum('03', 'enum_03', '3年　'),
  enum_04: new CodeTextEnum('04', 'enum_04', '4年　'),
  enum_05: new CodeTextEnum('05', 'enum_05', '5年'),
  enum_06: new CodeTextEnum('06', 'enum_06', '6年　'),
  enum_07: new CodeTextEnum('07', 'enum_07', '7年'),
  enum_08: new CodeTextEnum('08', 'enum_08', '8年　'),
  enum_09: new CodeTextEnum('09', 'enum_09', '9年　'),
  enum_10: new CodeTextEnum('10', 'enum_10', '10年'),
})
// 未採用フラグ
const unAdoptedFlgEnum = Object.freeze({
  enum_01: new CodeTextEnum('01', 'enum_01', '仕様変更'),
  enum_02: new CodeTextEnum('02', 'enum_02', '提案したが先方の意向で先送り'),
  enum_03: new CodeTextEnum('03', 'enum_03', '提案せずに先送り'),
  enum_04: new CodeTextEnum('04', 'enum_04', '他社受注'),
  enum_05: new CodeTextEnum('05', 'enum_05', '計画が白紙'),
  enum_06: new CodeTextEnum('06', 'enum_06', '実施済'),
  enum_07: new CodeTextEnum('07', 'enum_07', 'ＳＣ１へ移行'),
  enum_08: new CodeTextEnum('08', 'enum_08', 'ＳＣ２へ移行'),
  enum_09: new CodeTextEnum('09', 'enum_09', '他案件と合体'),
  enum_10: new CodeTextEnum('10', 'enum_10', '重複計上'),
  enum_99: new CodeTextEnum('99', 'enum_99', 'その他(管理解約等)'),
})
// 取消フラグ
const cancelFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '取消'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '有効'),
})
// 非課税フラグ
const noTaxFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '非課税'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '課税'),
})
// 完了フラグ
const finishFlgEnum = Object.freeze({
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '未完了'),
  enum_1: new CodeTextEnum('1', 'enum_1', '完了'),
})
// 注文印刷住所フラグ
const printAdrsFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '見積住所を「虎ノ門」にて印字'),
  enum_2: new CodeTextEnum('2', 'enum_2', '見積住所を「新大阪」にて印字'),
  enum_3: new CodeTextEnum(
    '3',
    'enum_3',
    '見積印字部門を進行部門、見積住所を「虎ノ門」にて印字'
  ),
  enum_4: new CodeTextEnum(
    '4',
    'enum_4',
    '見積印字部門を進行部門、見積住所を「関西支社」にて印字'
  ),
  enum_5: new CodeTextEnum(
    '5',
    'enum_5',
    '見積印字部門、見積住所を「進行部門」にて印字'
  ),
  enum_6: new CodeTextEnum(
    '6',
    'enum_6',
    'チェックなしの場合、見積印字部門、見積住所は計上部門'
  ),
  enum_7: new CodeTextEnum(
    '7',
    'enum_7',
    'チェックなしの場合、見積印字部門、見積住所は進行部門'
  ),
})
// １円調整フラグ
const adj1yenFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '税端数（＋１）'),
  enum_2: new CodeTextEnum('2', 'enum_2', '税端数（－１）'),
})
// 緊急対応フラグ
const emergencySupportFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '緊急対応'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '非緊急対応'),
})
// 石綿対応
const asbestoContainFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '石綿含有'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '石綿含有無'),
})
// ｅｃｏ文書フラグ
const ecoDocFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '利用する'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '利用しない'),
})
// 連携フラグ
const alignFlgEnum = Object.freeze({
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '未連携'),
  enum_1: new CodeTextEnum('1', 'enum_1', '連携済'),
  enum_2: new CodeTextEnum('2', 'enum_2', 'アップロード済'),
  enum_3: new CodeTextEnum('3', 'enum_3', 'ダウンロード済'),
})
// 出力区分
const outputFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '出力'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '未出力'),
})
// 承認動作
const actionEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '承認申請'),
  enum_1: new CodeTextEnum('1', 'enum_1', '承認'),
  enum_2: new CodeTextEnum('2', 'enum_2', '否決'),
  enum_3: new CodeTextEnum('3', 'enum_3', '保留'),
  enum_4: new CodeTextEnum('4', 'enum_4', '承認取下'),
  enum_5: new CodeTextEnum('5', 'enum_5', 'キャンセル申請'),
  enum_6: new CodeTextEnum('6', 'enum_6', '申請取消'),
  enum_7: new CodeTextEnum('7', 'enum_7', '差戾'),
})
// プロセスインスタンスステータス
const procInstStatusEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', 'アクティブ'),
  enum_1: new CodeTextEnum('1', 'enum_1', '保留中'),
  enum_2: new CodeTextEnum('2', 'enum_2', '完了'),
})
// 見積承認タイプ
const estimateTypeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '原価'),
  enum_2: new CodeTextEnum('2', 'enum_2', '売価'),
  enum_3: new CodeTextEnum('3', 'enum_3', '原価売価'),
  enum_4: new CodeTextEnum('4', 'enum_4', '原価再登録'),
})
// 請求予定月フラグ
const billPlanMonthFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '当月'),
  enum_2: new CodeTextEnum('2', 'enum_2', '翌月'),
  enum_3: new CodeTextEnum('3', 'enum_3', '前月'),
})
// 入金予定月ｃｄ
const depositPlanMonthCdEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '請求同月'),
  enum_2: new CodeTextEnum('2', 'enum_2', '請求翌月'),
  enum_3: new CodeTextEnum('3', 'enum_3', '請求翌々月'),
  enum_4: new CodeTextEnum('4', 'enum_4', '請求翌翌々月'),
  enum_5: new CodeTextEnum('5', 'enum_5', '請求の4ヶ月後'),
})
// 請求出力方法
const billOutputClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '日次'),
  enum_2: new CodeTextEnum('2', 'enum_2', '月次'),
  enum_3: new CodeTextEnum('3', 'enum_3', '個別'),
})
// ｍｓ会計取得済フラグ
const msAccountAcquiredFlagEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '取得待ち'),
  enum_2: new CodeTextEnum('2', 'enum_2', '取得済み'),
})
// 受託作業区分
const entrustedWorkFlagEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '受託契約以外'),
  enum_1: new CodeTextEnum('1', 'enum_1', '受託契約'),
})
// 採番区分
const sequenceDivisionEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '案件'),
  enum_2: new CodeTextEnum('2', 'enum_2', '提案計画'),
  enum_3: new CodeTextEnum('3', 'enum_3', '受注'),
  enum_4: new CodeTextEnum('4', 'enum_4', '作業'),
  enum_5: new CodeTextEnum('5', 'enum_5', '被請求'),
  enum_6: new CodeTextEnum('6', 'enum_6', '印刷リクエスト'),
})
// 有効フラグ
const validFlgEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '無効'),
  enum_1: new CodeTextEnum('1', 'enum_1', '有効'),
})
// 無効フラグ
const invalidFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '無効'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '有効'),
})
// 終了もの含む
const finishedContainFlagEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '終了したものを含まない'),
  enum_2: new CodeTextEnum('2', 'enum_2', '終了したものを含む'),
})
// 権限タイプ
const permissionTypeEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '照会'),
  enum_1: new CodeTextEnum('1', 'enum_1', '更新'),
  enum_2: new CodeTextEnum('2', 'enum_2', '照会と更新'),
})
// 提案計画反映フラグ
const proposalApplyFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '反映済'),
  enum_0: new CodeTextEnum('0', 'enum_0', '未反映'),
})
// 勤務仕様
const knmmcdEnum = Object.freeze({
  enum_00: new CodeTextEnum('00', 'enum_00', '未登録　'),
  enum_01: new CodeTextEnum('01', 'enum_01', '１回／週　'),
  enum_02: new CodeTextEnum('02', 'enum_02', '２回／週　'),
  enum_03: new CodeTextEnum('03', 'enum_03', '３回／週　'),
  enum_04: new CodeTextEnum('04', 'enum_04', '４回／週　'),
  enum_05: new CodeTextEnum('05', 'enum_05', '５回／週　'),
  enum_06: new CodeTextEnum('06', 'enum_06', '６回／週　'),
  enum_07: new CodeTextEnum('07', 'enum_07', '１回／隔週　'),
  enum_08: new CodeTextEnum('08', 'enum_08', '１回／月　'),
  enum_09: new CodeTextEnum('09', 'enum_09', '２回／月　'),
  enum_10: new CodeTextEnum('10', 'enum_10', '３回／月　'),
  enum_11: new CodeTextEnum('11', 'enum_11', '４回／月　  '),
  enum_12: new CodeTextEnum('12', 'enum_12', '２回／隔週'),
  enum_13: new CodeTextEnum('13', 'enum_13', '７回／週　'),
  enum_14: new CodeTextEnum('14', 'enum_14', '適宜（削除） '),
  enum_15: new CodeTextEnum('15', 'enum_15', '週３０時間　'),
  enum_16: new CodeTextEnum('16', 'enum_16', 'シフト勤務'),
  enum_17: new CodeTextEnum('17', 'enum_17', '週４０時間　'),
  enum_99: new CodeTextEnum('99', 'enum_99', 'その他'),
})
// 祝日フラグ
const hldfEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '祝日は出勤'),
  enum_1: new CodeTextEnum('1', 'enum_1', '祝日は休日'),
  enum_2: new CodeTextEnum('2', 'enum_2', '休管の出勤'),
  enum_3: new CodeTextEnum('3', 'enum_3', '休管の祝日は休日'),
  enum_4: new CodeTextEnum('4', 'enum_4', '祝日のみ勤務'),
})
// 排水制限
const drainageLimitEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '排水停止'),
  enum_1: new CodeTextEnum('1', 'enum_1', '排水ＯＫ'),
})
// 産廃処理区分
const trashTreatDivisionEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '1対1'),
  enum_1: new CodeTextEnum('1', 'enum_1', '少量'),
  enum_2: new CodeTextEnum('2', 'enum_2', '無'),
  enum_3: new CodeTextEnum('3', 'enum_3', 'フレコン'),
})
// 作成状態フラグ
const crtstsfEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '提案計画活動中として作成'),
  enum_2: new CodeTextEnum('2', 'enum_2', '受注登録中として作成'),
  enum_3: new CodeTextEnum('3', 'enum_3', '受注済みとして作成'),
})
// 見積値引区分
const estimateDiscountTypeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '出精値引'),
  enum_2: new CodeTextEnum('2', 'enum_2', '端数調整'),
})
// エスカレーション承認区分
const escalationApprovalClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', 'エスカレーション承認'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', 'エスカレーション非承認'),
})
// 原価ゼロ発注ｃフラグ
const costZeroFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '原価ゼロ発注書C作成'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '原価ゼロ発注書C非作成'),
})
// 産業廃棄物
const industryTrashFlgEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '現地指定場所で保管'),
  enum_1: new CodeTextEnum('1', 'enum_1', '指定場所へ運搬'),
})
// 専任有無区分
const fullTimeClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '専任なし'),
  enum_2: new CodeTextEnum('2', 'enum_2', '専任あり'),
})
// 主任監理区分
const chiefSuperClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '主任'),
  enum_2: new CodeTextEnum('2', 'enum_2', '監理'),
})
// 工事記録簿受注拒否アクション
const constructionRecordAcceptOrderDenyActionEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '否決なし'),
  enum_1: new CodeTextEnum('1', 'enum_1', '受注確認否決'),
  enum_2: new CodeTextEnum('2', 'enum_2', '受注締結否決'),
  enum_3: new CodeTextEnum('3', 'enum_3', '完了報告書否決'),
  enum_4: new CodeTextEnum('4', 'enum_4', '組合完了確認書否決'),
})
// 工事記録簿発注拒否アクション
const constructionRecordOrderDenyActionEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '否決なし'),
  enum_1: new CodeTextEnum('1', 'enum_1', '下請締結否決'),
  enum_2: new CodeTextEnum('2', 'enum_2', '下請完了否決'),
})
// 不可フラグ
const canNotFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '不可'),
  enum_0: new CodeTextEnum('0', 'enum_0', '可'),
})
// 可否区分
const canFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '可'),
  enum_0: new CodeTextEnum('0', 'enum_0', '不可'),
})
// 計上部門区分
const accountingDepClassEnum = Object.freeze({
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '区分なし'),
  enum_1: new CodeTextEnum('1', 'enum_1', '計上部門'),
})
// 納品完了ステータス
const deliveryFinishStatusEnum = Object.freeze({
  enum_401: new CodeTextEnum('401', 'enum_401', '納品完了未登録'),
  enum_402: new CodeTextEnum('402', 'enum_402', '納品完了登録中'),
  enum_403: new CodeTextEnum('403', 'enum_403', '納品完了承認待ち'),
  enum_400: new CodeTextEnum('400', 'enum_400', '納品完了'),
})
// 一時ファイル区分
const tempFileTypeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '共通書類'),
  enum_2: new CodeTextEnum('2', 'enum_2', '協力会社見積書類'),
  enum_3: new CodeTextEnum('3', 'enum_3', '見積書類'),
  enum_4: new CodeTextEnum('4', 'enum_4', '受注書類'),
  enum_5: new CodeTextEnum('5', 'enum_5', '発注書類'),
  enum_6: new CodeTextEnum('6', 'enum_6', '納品書類'),
})
// 工事役務区分
const workServiceClassEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '建設工事'),
  enum_1: new CodeTextEnum('1', 'enum_1', '役務'),
})
// 工事記録簿発注承認タイプ
const constructionRecordPurOrderTypeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '下請締結'),
  enum_2: new CodeTextEnum('2', 'enum_2', '下請完了書類'),
})
// 工事記録簿承認タイプ
const constructionRecordBaseTypeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '受注確認'),
  enum_2: new CodeTextEnum('2', 'enum_2', '受注締結'),
  enum_3: new CodeTextEnum('3', 'enum_3', '完了報告書'),
  enum_4: new CodeTextEnum('4', 'enum_4', '組合完了確認書'),
})
// 調査入力済フラグ
const surveyEnteredFlagEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '入力済'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '入力中'),
})
// 担当区分
const chargeRoleEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', 'メイン担当'),
  enum_2: new CodeTextEnum('2', 'enum_2', 'サブ担当'),
})
// 担当種別
const chargeTypeEnum = Object.freeze({
  enum_01: new CodeTextEnum('01', 'enum_01', '計上担当者'),
  enum_02: new CodeTextEnum('02', 'enum_02', '進行担当者'),
  enum_03: new CodeTextEnum('03', 'enum_03', '受注担当者(計画)'),
  enum_04: new CodeTextEnum('04', 'enum_04', '診断担当者(管理)'),
  enum_05: new CodeTextEnum('05', 'enum_05', '主任・監理技術者'),
  enum_06: new CodeTextEnum('06', 'enum_06', '管理（推進）担当'),
})
// 書類区分
const docClassEnum = Object.freeze({
  enum_01: new CodeTextEnum('01', 'enum_01', '工事用見積条件書'),
  enum_02: new CodeTextEnum('02', 'enum_02', '役務用見積条件書'),
  enum_08: new CodeTextEnum('08', 'enum_08', '日程調整連携資料（協力会社）'),
  enum_09: new CodeTextEnum('09', 'enum_09', '日程調整連携資料（社内）'),
  enum_10: new CodeTextEnum('10', 'enum_10', '現地調査依頼書類'),
  enum_12: new CodeTextEnum('12', 'enum_12', 'SC2工事日程調整書類'),
  enum_13: new CodeTextEnum('13', 'enum_13', 'SC3日程調整書類'),
  enum_18: new CodeTextEnum('18', 'enum_18', '掲示物'),
  enum_19: new CodeTextEnum('19', 'enum_19', '前日リマインド'),
  enum_21: new CodeTextEnum('21', 'enum_21', 'SC1報告書'),
  enum_22: new CodeTextEnum('22', 'enum_22', 'SC2報告書'),
  enum_23: new CodeTextEnum('23', 'enum_23', 'SC3報告書'),
  enum_24: new CodeTextEnum('24', 'enum_24', 'RCS（スポット）報告書'),
})
// テンプレートcd
const mailTemplateCdEnum = Object.freeze({
  enum_T01: new CodeTextEnum('T01', 'enum_T01', '協力会社一括メール'),
  enum_T02: new CodeTextEnum('T02', 'enum_T02', '準備アラートメール'),
  enum_T03: new CodeTextEnum('T03', 'enum_T03', '報告書提出メール'),
  enum_T04: new CodeTextEnum('T04', 'enum_T04', '対応不可メール'),
  enum_T05: new CodeTextEnum('T05', 'enum_T05', '現地調査不要メール'),
  enum_T06: new CodeTextEnum('T06', 'enum_T06', '作業可能日回答メール'),
  enum_T07: new CodeTextEnum('T07', 'enum_T07', '日程提出一括催促メール'),
  enum_T08: new CodeTextEnum('T08', 'enum_T08', '日程差戻メール'),
  enum_T09: new CodeTextEnum(
    'T09',
    'enum_T09',
    '日程再調整メール（協力会社向け）'
  ),
  enum_T10: new CodeTextEnum('T10', 'enum_T10', '依頼書類提出一括催促メール'),
  enum_T11: new CodeTextEnum('T11', 'enum_T11', '依頼書類提出催促メール'),
  enum_T12: new CodeTextEnum('T12', 'enum_T12', '依頼書類差戻メール'),
  enum_T13: new CodeTextEnum('T13', 'enum_T13', '着工広報リマインドメール'),
  enum_T14: new CodeTextEnum('T14', 'enum_T14', '着工広報通知メール'),
  enum_T15: new CodeTextEnum('T15', 'enum_T15', '掲示物登録メール'),
  enum_T16: new CodeTextEnum('T16', 'enum_T16', '作業リマインドメール'),
  enum_T17: new CodeTextEnum('T17', 'enum_T17', '報告書提出一括催促メール'),
  enum_T18: new CodeTextEnum('T18', 'enum_T18', '報告書提出催促メール'),
  enum_T19: new CodeTextEnum('T19', 'enum_T19', '報告書差戻メール'),
  enum_T20: new CodeTextEnum('T20', 'enum_T20', '報告書連携メール'),
  enum_T21: new CodeTextEnum('T21', 'enum_T21', '日程調整依頼取消メール'),
  enum_T22: new CodeTextEnum('T22', 'enum_T22', '着工広報引戻メール'),
  enum_T23: new CodeTextEnum('T23', 'enum_T23', '作業可能日依頼取消メール'),
  enum_T24: new CodeTextEnum('T24', 'enum_T24', '作業予実未入力一括催促メール'),
  enum_T25: new CodeTextEnum('T25', 'enum_T25', '日程調整依頼済メール'),
  enum_T26: new CodeTextEnum('T26', 'enum_T26', '作業可能日依頼済メール'),
  enum_T27: new CodeTextEnum(
    'T27',
    'enum_T27',
    '日程提出済（進行担当向け）メール'
  ),
  enum_T28: new CodeTextEnum('T28', 'enum_T28', '日程提出済（LC向け）メール'),
  enum_T29: new CodeTextEnum(
    'T29',
    'enum_T29',
    '日程確認済（進行担当向け）メール'
  ),
  enum_T30: new CodeTextEnum(
    'T30',
    'enum_T30',
    '日程確認済（LC/FM向け）メール'
  ),
  enum_T31: new CodeTextEnum(
    'T31',
    'enum_T31',
    '日程確認済（協力会社向け）メール'
  ),
  enum_T32: new CodeTextEnum('T32', 'enum_T32', '見積共有資料メール'),
  enum_T33: new CodeTextEnum('T33', 'enum_T33', '社内資料連携メール'),
  enum_T34: new CodeTextEnum(
    'T34',
    'enum_T34',
    '作業日程マッチング済（協力会社向け）メール'
  ),
  enum_T35: new CodeTextEnum('T35', 'enum_T35', '依頼書類提出済メール'),
  enum_T36: new CodeTextEnum('T36', 'enum_T36', '作業実績未入力一括催促メール'),
  enum_T37: new CodeTextEnum('T37', 'enum_T37', '報告書未提出催促メール'),
  enum_T38: new CodeTextEnum('T38', 'enum_T38', '作業予定日入力のお知らせ'),
  enum_T39: new CodeTextEnum('T39', 'enum_T39', '作業予定日可否確認メール'),
  enum_T40: new CodeTextEnum('T40', 'enum_T40', '作業予定日提出差戻メール'),
  enum_T41: new CodeTextEnum('T41', 'enum_T41', 'RC報告書差戻メール'),
  enum_T42: new CodeTextEnum('T42', 'enum_T42', '作業予定記入表'),
  enum_T43: new CodeTextEnum(
    'T43',
    'enum_T43',
    '日程未記入リマインド(締め日前)'
  ),
  enum_T44: new CodeTextEnum('T44', 'enum_T44', '未記入プッシュ'),
  enum_T45: new CodeTextEnum('T45', 'enum_T45', '不可日プッシュ'),
  enum_T46: new CodeTextEnum('T46', 'enum_T46', '日程調整_DLN→協力会社'),
  enum_T47: new CodeTextEnum('T47', 'enum_T47', '日程調整_協力会社→DLN'),
  enum_T48: new CodeTextEnum('T48', 'enum_T48', '作業予定確認表'),
  enum_T49: new CodeTextEnum('T49', 'enum_T49', '予定日広報'),
  enum_T50: new CodeTextEnum('T50', 'enum_T50', '概要書完成通知メール'),
  enum_T51: new CodeTextEnum(
    'T51',
    'enum_T51',
    '日程再調整メール（進行担当向け）'
  ),
  enum_T52: new CodeTextEnum('T52', 'enum_T52', '日程変更依頼取消メール'),
  enum_T53: new CodeTextEnum('T53', 'enum_T53', '		報告書未提出一括催促メール'),
  enum_T54: new CodeTextEnum('T54', 'enum_T54', '報告書未着のお知らせメール'),
  enum_T55: new CodeTextEnum('T55', 'enum_T55', '正式版報告書未提出催促メール'),
  enum_T56: new CodeTextEnum(
    'T56',
    'enum_T56',
    'LCへ報告書未提出一括催促メール'
  ),
  enum_T57: new CodeTextEnum('T57', 'enum_T57', '作業変更日が入力済みのご連絡'),
  enum_T58: new CodeTextEnum(
    'T58',
    'enum_T58',
    '日程変更依頼取消メール(進行担当向け)'
  ),
  enum_T59: new CodeTextEnum('T59', 'enum_T59', '作業日程確定のお知らせメール'),
  enum_T60: new CodeTextEnum('T60', 'enum_T60', 'LCへ報告書未提出催促メール'),
  enum_E01: new CodeTextEnum(
    'E01',
    'enum_E01',
    '見積条件書送信の ご連絡(工事記録簿対象)'
  ),
  enum_E02: new CodeTextEnum(
    'E02',
    'enum_E02',
    '見積原価承認依頼の ご連絡(工事記録簿対象)'
  ),
  enum_E03: new CodeTextEnum(
    'E03',
    'enum_E03',
    '見積登録依頼の ご連絡(工事記録簿対象)'
  ),
  enum_E04: new CodeTextEnum(
    'E04',
    'enum_E04',
    '原価承認否決の ご連絡(工事記録簿対象)'
  ),
  enum_E05: new CodeTextEnum(
    'E05',
    'enum_E05',
    '原価承認保留の ご連絡(工事記録簿対象)'
  ),
  enum_E06: new CodeTextEnum(
    'E06',
    'enum_E06',
    '原価承認取下の ご連絡(工事記録簿対象)'
  ),
  enum_E07: new CodeTextEnum(
    'E07',
    'enum_E07',
    '原価承認差戻の ご連絡(工事記録簿対象)'
  ),
  enum_E08: new CodeTextEnum(
    'E08',
    'enum_E08',
    '見積承認申請依頼の ご連絡(工事記録簿対象)'
  ),
  enum_E09: new CodeTextEnum(
    'E09',
    'enum_E09',
    '見積承認完了の ご連絡(工事記録簿対象)'
  ),
  enum_E10: new CodeTextEnum(
    'E10',
    'enum_E10',
    '見積承認否決の ご連絡(工事記録簿対象)'
  ),
  enum_E11: new CodeTextEnum(
    'E11',
    'enum_E11',
    '見積承認保留の ご連絡(工事記録簿対象)'
  ),
  enum_E12: new CodeTextEnum(
    'E12',
    'enum_E12',
    '見積承認取下の ご連絡(工事記録簿対象)'
  ),
  enum_E13: new CodeTextEnum(
    'E13',
    'enum_E13',
    '見積承認差戻の ご連絡(工事記録簿対象)'
  ),
  enum_E14: new CodeTextEnum(
    'E14',
    'enum_E14',
    '原価再承認完了の ご連絡(工事記録簿対象)'
  ),
  enum_E15: new CodeTextEnum(
    'E15',
    'enum_E15',
    '見積採用の ご連絡(工事記録簿対象)'
  ),
  enum_E16: new CodeTextEnum('E16', 'enum_E16', '見積原価承認依頼の ご連絡'),
  enum_E17: new CodeTextEnum('E17', 'enum_E17', '見積登録依頼の ご連絡'),
  enum_E18: new CodeTextEnum('E18', 'enum_E18', '原価承認否決の ご連絡'),
  enum_E19: new CodeTextEnum('E19', 'enum_E19', '原価承認保留の ご連絡'),
  enum_E20: new CodeTextEnum('E20', 'enum_E20', '原価承認取下の ご連絡'),
  enum_E21: new CodeTextEnum('E21', 'enum_E21', '原価承認差戻の ご連絡'),
  enum_E22: new CodeTextEnum('E22', 'enum_E22', '見積承認申請依頼の ご連絡'),
  enum_E23: new CodeTextEnum('E23', 'enum_E23', '見積承認完了の ご連絡'),
  enum_E24: new CodeTextEnum('E24', 'enum_E24', '見積承認否決の ご連絡'),
  enum_E25: new CodeTextEnum('E25', 'enum_E25', '見積承認保留の ご連絡'),
  enum_E26: new CodeTextEnum('E26', 'enum_E26', '見積承認取下の ご連絡'),
  enum_E27: new CodeTextEnum('E27', 'enum_E27', '見積承認差戻の ご連絡'),
  enum_E28: new CodeTextEnum('E28', 'enum_E28', '原価再承認完了の ご連絡'),
  enum_E29: new CodeTextEnum('E29', 'enum_E29', '見積採用の ご連絡'),
  enum_E30: new CodeTextEnum(
    'E30',
    'enum_E30',
    '原価見積商品コード確認依頼の ご連絡'
  ),
  enum_E31: new CodeTextEnum(
    'E31',
    'enum_E31',
    '原価見積商品コード確認否決の ご連絡'
  ),
  enum_E32: new CodeTextEnum(
    'E32',
    'enum_E32',
    '原価見積商品コード確認保留の ご連絡'
  ),
  enum_E33: new CodeTextEnum('E33', 'enum_E33', '見積確認完了の ご連絡'),
  enum_A01: new CodeTextEnum(
    'A01',
    'enum_A01',
    '受注確認承認依頼の ご連絡(工事記録簿対象)'
  ),
  enum_A02: new CodeTextEnum(
    'A02',
    'enum_A02',
    '見積採用・受注登録の ご連絡(工事記録簿対象)'
  ),
  enum_A03: new CodeTextEnum(
    'A03',
    'enum_A03',
    '受注確認承認否決の ご連絡(工事記録簿対象)'
  ),
  enum_A04: new CodeTextEnum(
    'A04',
    'enum_A04',
    '受注確認承認保留の ご連絡(工事記録簿対象)'
  ),
  enum_A05: new CodeTextEnum(
    'A05',
    'enum_A05',
    '受注確認承認取下の ご連絡(工事記録簿対象)'
  ),
  enum_A06: new CodeTextEnum(
    'A06',
    'enum_A06',
    '受注確認承認差戻の ご連絡(工事記録簿対象)'
  ),
  enum_A07: new CodeTextEnum(
    'A07',
    'enum_A07',
    '受注承認申請のご連絡(工事記録簿対象)'
  ),
  enum_A08: new CodeTextEnum(
    'A08',
    'enum_A08',
    '受注承認完了の ご連絡(工事記録簿対象)'
  ),
  enum_A09: new CodeTextEnum(
    'A09',
    'enum_A09',
    '受注承認否決の ご連絡(工事記録簿対象)'
  ),
  enum_A10: new CodeTextEnum(
    'A10',
    'enum_A10',
    '受注承認保留の ご連絡(工事記録簿対象)'
  ),
  enum_A11: new CodeTextEnum(
    'A11',
    'enum_A11',
    '受注承認取下の ご連絡(工事記録簿対象)'
  ),
  enum_A12: new CodeTextEnum(
    'A12',
    'enum_A12',
    '受注承認差戻の ご連絡(工事記録簿対象)'
  ),
  enum_A13: new CodeTextEnum(
    'A13',
    'enum_A13',
    '受注変更承認申請のご連絡(工事記録簿対象)'
  ),
  enum_A14: new CodeTextEnum(
    'A14',
    'enum_A14',
    '受注変更承認完了の ご連絡(工事記録簿対象)'
  ),
  enum_A15: new CodeTextEnum(
    'A15',
    'enum_A15',
    '受注変更承認否決の ご連絡(工事記録簿対象)'
  ),
  enum_A16: new CodeTextEnum(
    'A16',
    'enum_A16',
    '受注変更承認保留の ご連絡(工事記録簿対象)'
  ),
  enum_A17: new CodeTextEnum(
    'A17',
    'enum_A17',
    '受注変更承認取下の ご連絡(工事記録簿対象)'
  ),
  enum_A18: new CodeTextEnum(
    'A18',
    'enum_A18',
    '受注変更承認差戻の ご連絡(工事記録簿対象)'
  ),
  enum_A19: new CodeTextEnum(
    'A19',
    'enum_A19',
    '受注キャンセル承認申請の ご連絡(工事記録簿対象)'
  ),
  enum_A20: new CodeTextEnum(
    'A20',
    'enum_A20',
    '受注キャンセル承認完了の ご連絡(工事記録簿対象)'
  ),
  enum_A21: new CodeTextEnum(
    'A21',
    'enum_A21',
    '受注キャンセル承認否決の ご連絡(工事記録簿対象)'
  ),
  enum_A22: new CodeTextEnum(
    'A22',
    'enum_A22',
    '受注キャンセル承認保留の ご連絡(工事記録簿対象)'
  ),
  enum_A23: new CodeTextEnum(
    'A23',
    'enum_A23',
    '受注キャンセル承認取下の ご連絡(工事記録簿対象)'
  ),
  enum_A24: new CodeTextEnum(
    'A24',
    'enum_A24',
    '受注キャンセル承認差戻の ご連絡(工事記録簿対象)'
  ),
  enum_A25: new CodeTextEnum('A25', 'enum_A25', '受注承認申請のご連絡'),
  enum_A26: new CodeTextEnum('A26', 'enum_A26', '受注承認完了の ご連絡'),
  enum_A27: new CodeTextEnum('A27', 'enum_A27', '受注承認否決の ご連絡'),
  enum_A28: new CodeTextEnum('A28', 'enum_A28', '受注承認保留の ご連絡'),
  enum_A29: new CodeTextEnum('A29', 'enum_A29', '受注承認取下の ご連絡'),
  enum_A30: new CodeTextEnum('A30', 'enum_A30', '受注承認差戻の ご連絡'),
  enum_A31: new CodeTextEnum('A31', 'enum_A31', '受注変更承認申請のご連絡'),
  enum_A32: new CodeTextEnum('A32', 'enum_A32', '受注変更承認完了の ご連絡'),
  enum_A33: new CodeTextEnum('A33', 'enum_A33', '受注変更承認否決の ご連絡'),
  enum_A34: new CodeTextEnum('A34', 'enum_A34', '受注変更承認保留の ご連絡'),
  enum_A35: new CodeTextEnum('A35', 'enum_A35', '受注変更承認取下の ご連絡'),
  enum_A36: new CodeTextEnum('A36', 'enum_A36', '受注変更承認差戻の ご連絡'),
  enum_A37: new CodeTextEnum(
    'A37',
    'enum_A37',
    '受注キャンセル承認申請の ご連絡'
  ),
  enum_A38: new CodeTextEnum(
    'A38',
    'enum_A38',
    '受注キャンセル承認完了の ご連絡'
  ),
  enum_A39: new CodeTextEnum(
    'A39',
    'enum_A39',
    '受注キャンセル承認否決の ご連絡'
  ),
  enum_A40: new CodeTextEnum(
    'A40',
    'enum_A40',
    '受注キャンセル承認保留の ご連絡'
  ),
  enum_A41: new CodeTextEnum(
    'A41',
    'enum_A41',
    '受注キャンセル承認取下の ご連絡'
  ),
  enum_A42: new CodeTextEnum(
    'A42',
    'enum_A42',
    '受注キャンセル承認差戻の ご連絡'
  ),
  enum_A43: new CodeTextEnum(
    'A43',
    'enum_A43',
    '受注締結登録確認依頼の ご連絡(工事記録簿対象)'
  ),
  enum_A44: new CodeTextEnum(
    'A44',
    'enum_A44',
    '受注締結登録確認完了の ご連絡(工事記録簿対象)'
  ),
  enum_A45: new CodeTextEnum(
    'A45',
    'enum_A45',
    '受注締結承認否決の ご連絡(工事記録簿対象)'
  ),
  enum_A46: new CodeTextEnum(
    'A46',
    'enum_A46',
    '受注締結承認保留の ご連絡(工事記録簿対象)'
  ),
  enum_A47: new CodeTextEnum(
    'A47',
    'enum_A47',
    '受注締結承認取下の ご連絡(工事記録簿対象)'
  ),
  enum_A48: new CodeTextEnum(
    'A48',
    'enum_A48',
    '受注締結承認差戻の ご連絡(工事記録簿対象)'
  ),
  enum_P01: new CodeTextEnum(
    'P01',
    'enum_P01',
    '発注承認申請の ご連絡(工事記録簿対象)'
  ),
  enum_P02: new CodeTextEnum(
    'P02',
    'enum_P02',
    '発注承認完了の ご連絡(工事記録簿対象)'
  ),
  enum_P03: new CodeTextEnum(
    'P03',
    'enum_P03',
    '発注承認否決の ご連絡(工事記録簿対象)'
  ),
  enum_P04: new CodeTextEnum(
    'P04',
    'enum_P04',
    '発注承認保留の ご連絡(工事記録簿対象)'
  ),
  enum_P05: new CodeTextEnum(
    'P05',
    'enum_P05',
    '発注承認取下の ご連絡(工事記録簿対象)'
  ),
  enum_P06: new CodeTextEnum(
    'P06',
    'enum_P06',
    '発注承認差戻の ご連絡(工事記録簿対象)'
  ),
  enum_P07: new CodeTextEnum(
    'P07',
    'enum_P07',
    '発注変更承認申請のご連絡(工事記録簿対象)'
  ),
  enum_P08: new CodeTextEnum(
    'P08',
    'enum_P08',
    '発注変更承認完了の ご連絡(工事記録簿対象)'
  ),
  enum_P09: new CodeTextEnum(
    'P09',
    'enum_P09',
    '発注変更承認否決の ご連絡(工事記録簿対象)'
  ),
  enum_P10: new CodeTextEnum(
    'P10',
    'enum_P10',
    '発注変更承認保留の ご連絡(工事記録簿対象)'
  ),
  enum_P11: new CodeTextEnum(
    'P11',
    'enum_P11',
    '発注変更承認取下の ご連絡(工事記録簿対象)'
  ),
  enum_P12: new CodeTextEnum(
    'P12',
    'enum_P12',
    '発注変更承認差戻の ご連絡(工事記録簿対象)'
  ),
  enum_P13: new CodeTextEnum(
    'P13',
    'enum_P13',
    '発注キャンセル承認申請の ご連絡(工事記録簿対象)'
  ),
  enum_P14: new CodeTextEnum(
    'P14',
    'enum_P14',
    '発注キャンセル承認完了の ご連絡(工事記録簿対象)'
  ),
  enum_P15: new CodeTextEnum(
    'P15',
    'enum_P15',
    '発注キャンセル承認否決の ご連絡(工事記録簿対象)'
  ),
  enum_P16: new CodeTextEnum(
    'P16',
    'enum_P16',
    '発注キャンセル承認保留の ご連絡(工事記録簿対象)'
  ),
  enum_P17: new CodeTextEnum(
    'P17',
    'enum_P17',
    '発注キャンセル承認取下の ご連絡(工事記録簿対象)'
  ),
  enum_P18: new CodeTextEnum(
    'P18',
    'enum_P18',
    '発注キャンセル承認差戻の ご連絡(工事記録簿対象)'
  ),
  enum_P19: new CodeTextEnum('P19', 'enum_P19', '発注承認申請の ご連絡'),
  enum_P20: new CodeTextEnum('P20', 'enum_P20', '発注承認完了の ご連絡'),
  enum_P21: new CodeTextEnum('P21', 'enum_P21', '発注承認否決の ご連絡'),
  enum_P22: new CodeTextEnum('P22', 'enum_P22', '発注承認保留の ご連絡'),
  enum_P23: new CodeTextEnum('P23', 'enum_P23', '発注承認取下の ご連絡'),
  enum_P24: new CodeTextEnum('P24', 'enum_P24', '発注承認差戻の ご連絡'),
  enum_P25: new CodeTextEnum('P25', 'enum_P25', '発注変更承認申請のご連絡'),
  enum_P26: new CodeTextEnum('P26', 'enum_P26', '発注変更承認完了の ご連絡'),
  enum_P27: new CodeTextEnum('P27', 'enum_P27', '発注変更承認否決の ご連絡'),
  enum_P28: new CodeTextEnum('P28', 'enum_P28', '発注変更承認保留の ご連絡'),
  enum_P29: new CodeTextEnum('P29', 'enum_P29', '発注変更承認取下の ご連絡'),
  enum_P30: new CodeTextEnum('P30', 'enum_P30', '発注変更承認差戻の ご連絡'),
  enum_P31: new CodeTextEnum(
    'P31',
    'enum_P31',
    '発注キャンセル承認申請の ご連絡'
  ),
  enum_P32: new CodeTextEnum(
    'P32',
    'enum_P32',
    '発注キャンセル承認完了の ご連絡'
  ),
  enum_P33: new CodeTextEnum(
    'P33',
    'enum_P33',
    '発注キャンセル承認否決の ご連絡'
  ),
  enum_P34: new CodeTextEnum(
    'P34',
    'enum_P34',
    '発注キャンセル承認保留の ご連絡'
  ),
  enum_P35: new CodeTextEnum(
    'P35',
    'enum_P35',
    '発注キャンセル承認取下の ご連絡'
  ),
  enum_P36: new CodeTextEnum(
    'P36',
    'enum_P36',
    '発注キャンセル承認差戻の ご連絡'
  ),
  enum_P37: new CodeTextEnum(
    'P37',
    'enum_P37',
    '下請締結承認依頼の ご連絡(工事記録簿対象)'
  ),
  enum_P38: new CodeTextEnum(
    'P38',
    'enum_P38',
    '下請締結登録確認完了の ご連絡(工事記録簿対象)'
  ),
  enum_P39: new CodeTextEnum(
    'P39',
    'enum_P39',
    '下請締結承認否決の ご連絡(工事記録簿対象)'
  ),
  enum_P40: new CodeTextEnum(
    'P40',
    'enum_P40',
    '下請締結承認保留の ご連絡(工事記録簿対象)'
  ),
  enum_P41: new CodeTextEnum(
    'P41',
    'enum_P41',
    '下請締結承認取下の ご連絡(工事記録簿対象)'
  ),
  enum_P42: new CodeTextEnum(
    'P42',
    'enum_P42',
    '下請締結承認差戻の ご連絡(工事記録簿対象)'
  ),
  enum_D01: new CodeTextEnum(
    'D01',
    'enum_D01',
    '完了報告書承認依頼の ご連絡(工事記録簿対象)'
  ),
  enum_D02: new CodeTextEnum(
    'D02',
    'enum_D02',
    '完了報告書確認完了の ご連絡(工事記録簿対象)'
  ),
  enum_D03: new CodeTextEnum(
    'D03',
    'enum_D03',
    '完了報告書承認否決の ご連絡(工事記録簿対象)'
  ),
  enum_D04: new CodeTextEnum(
    'D04',
    'enum_D04',
    '完了報告書承認保留の ご連絡(工事記録簿対象)'
  ),
  enum_D05: new CodeTextEnum(
    'D05',
    'enum_D05',
    '完了報告書承認取下の ご連絡(工事記録簿対象)'
  ),
  enum_D06: new CodeTextEnum(
    'D06',
    'enum_D06',
    '完了報告書承認差戻の ご連絡(工事記録簿対象)'
  ),
  enum_D07: new CodeTextEnum(
    'D07',
    'enum_D07',
    '組合完了確認書承認依頼の ご連絡(工事記録簿対象)'
  ),
  enum_D08: new CodeTextEnum(
    'D08',
    'enum_D08',
    '納品完了登録依頼の ご連絡(工事記録簿対象)'
  ),
  enum_D09: new CodeTextEnum(
    'D09',
    'enum_D09',
    '組合完了確認書承認否決の ご連絡(工事記録簿対象)'
  ),
  enum_D10: new CodeTextEnum(
    'D10',
    'enum_D10',
    '組合完了確認書承認保留の ご連絡(工事記録簿対象)'
  ),
  enum_D11: new CodeTextEnum(
    'D11',
    'enum_D11',
    '組合完了確認書承認取下の ご連絡(工事記録簿対象)'
  ),
  enum_D12: new CodeTextEnum(
    'D12',
    'enum_D12',
    '組合完了確認書承認差戻の ご連絡(工事記録簿対象)'
  ),
  enum_D13: new CodeTextEnum(
    'D13',
    'enum_D13',
    '納品完了登録承認申請の ご連絡(工事記録簿対象)'
  ),
  enum_D14: new CodeTextEnum(
    'D14',
    'enum_D14',
    '納品完了登録承認完了の ご連絡(工事記録簿対象)'
  ),
  enum_D15: new CodeTextEnum(
    'D15',
    'enum_D15',
    '納品完了登録承認申請の ご連絡'
  ),
  enum_D16: new CodeTextEnum(
    'D16',
    'enum_D16',
    '納品完了登録承認完了の ご連絡'
  ),
  enum_D17: new CodeTextEnum(
    'D17',
    'enum_D17',
    '下請完了書類承認依頼の ご連絡(工事記録簿対象)'
  ),
  enum_D18: new CodeTextEnum(
    'D18',
    'enum_D18',
    '下請完了書類登録確認完了の ご連絡(工事記録簿対象)'
  ),
  enum_D19: new CodeTextEnum(
    'D19',
    'enum_D19',
    '下請完了書類承認否決の ご連絡(工事記録簿対象)'
  ),
  enum_D20: new CodeTextEnum(
    'D20',
    'enum_D20',
    '下請完了書類承認保留の ご連絡(工事記録簿対象)'
  ),
  enum_D21: new CodeTextEnum(
    'D21',
    'enum_D21',
    '下請完了書類承認取下の ご連絡(工事記録簿対象)'
  ),
  enum_D22: new CodeTextEnum(
    'D22',
    'enum_D22',
    '下請完了書類承認差戻の ご連絡(工事記録簿対象)'
  ),
  enum_D23: new CodeTextEnum(
    'D23',
    'enum_D23',
    '保証書登録完了の ご連絡(工事記録簿対象)'
  ),
  enum_D24: new CodeTextEnum(
    'D24',
    'enum_D24',
    '保証書登録確認完了の ご連絡(工事記録簿対象)'
  ),
  enum_D25: new CodeTextEnum(
    'D25',
    'enum_D25',
    '納品月変更の ご連絡(工事記録簿対象)'
  ),
  enum_D26: new CodeTextEnum(
    'D26',
    'enum_D26',
    '工期欄入力のお知らせの ご連絡(工事記録簿対象)'
  ),
  enum_O01: new CodeTextEnum('O01', 'enum_O01', '発注請書送付の ご連絡'),
  enum_O02: new CodeTextEnum('O02', 'enum_O02', '注文書署名通知'),
})
// 必須フラグ
const requiredFlgEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '任意'),
  enum_1: new CodeTextEnum('1', 'enum_1', '必須'),
})
// 未決フラグ
const decidedFlagEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '決定'),
  enum_0: new CodeTextEnum('0', 'enum_0', '未決'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', 'N/A'),
})
// 書類到着フラグ
const documentArrivalFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '到着'),
  enum_0: new CodeTextEnum('0', 'enum_0', '未着'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', 'N/A'),
})
// 操作タイプ
const operationTypeEnum = Object.freeze({
  enum_I: new CodeTextEnum('I', 'enum_I', 'Insert'),
  enum_U: new CodeTextEnum('U', 'enum_U', 'Update'),
  enum_D: new CodeTextEnum('D', 'enum_D', 'Delete'),
})
// 管理終了ｆ
const mngendfEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '管理中'),
  enum_1: new CodeTextEnum('1', 'enum_1', '管理終了'),
})
// 受取フラグ
const receiptFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '受取済'),
  enum_0: new CodeTextEnum('0', 'enum_0', '未受取'),
})
// 確認フラグ
const confirmFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '確認済'),
  enum_0: new CodeTextEnum('0', 'enum_0', '未確認'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', 'N/A'),
})
// 承認クラスｃｄ
const autclscdEnum = Object.freeze({
  enum_C0: new CodeTextEnum('C0', 'enum_C0', 'GL'),
  enum_C1: new CodeTextEnum('C1', 'enum_C1', '課長'),
  enum_C2: new CodeTextEnum('C2', 'enum_C2', '部長'),
  enum_C3: new CodeTextEnum('C3', 'enum_C3', '担当役員'),
  enum_C4: new CodeTextEnum('C4', 'enum_C4', '事業部長'),
  enum_C5: new CodeTextEnum('C5', 'enum_C5', '本部長'),
})
// 工事記録簿登録モード
const constructionRecordApprovalModeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '受注確認登録モード'),
  enum_2: new CodeTextEnum('2', 'enum_2', '受注締結登録モード'),
  enum_3: new CodeTextEnum('3', 'enum_3', '完了報告書登録モード'),
  enum_4: new CodeTextEnum('4', 'enum_4', '保証書登録モード'),
  enum_5: new CodeTextEnum('5', 'enum_5', '組合完了確認書登録モード'),
})
// 納品完了区分
const deliveryCompleteEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '非正常'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '通常'),
})
// 納品完了ステー
const deliveryCompleteStatusEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '納品完了承認待ち'),
  enum_2: new CodeTextEnum('2', 'enum_2', '納品完了保留中'),
})
// 見積アクションモード
const estimateActionModeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '登録モード'),
  enum_2: new CodeTextEnum('2', 'enum_2', '変更モード'),
  enum_3: new CodeTextEnum('3', 'enum_3', '照会モード'),
  enum_4: new CodeTextEnum('4', 'enum_4', '原価のみ変更モード'),
  enum_5: new CodeTextEnum('5', 'enum_5', '見積のみ変更モード'),
})
// 見積フロータイプ
const estimateFlowTypeEnum = Object.freeze({
  enum_1: new CodeTextEnum(
    '1',
    'enum_1',
    'スタンダード承認＆工事記録簿基本存在しない'
  ),
  enum_2: new CodeTextEnum(
    '2',
    'enum_2',
    'スタンダード承認＆工事記録簿基本存在して'
  ),
  enum_3: new CodeTextEnum('3', 'enum_3', 'エスカレーション承認'),
})
// 発注入力モード
const purchaseOrderEntryModeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '登録モード'),
  enum_2: new CodeTextEnum('2', 'enum_2', '承認前変更モード'),
  enum_3: new CodeTextEnum('3', 'enum_3', '承認後変更モード'),
})
// ステータス下請締結
const subcontractStatusSumEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', ' '),
  enum_1: new CodeTextEnum('1', 'enum_1', '下請締結登録中'),
  enum_2: new CodeTextEnum('2', 'enum_2', '下請締結承認待ち'),
  enum_3: new CodeTextEnum('3', 'enum_3', '下請締結済'),
  enum_4: new CodeTextEnum('4', 'enum_4', '下請締結保留中'),
  enum_5: new CodeTextEnum('5', 'enum_5', '承認待ちあり'),
})
// ステータス下請完了
const completedSubcontractStatusSumEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', ' '),
  enum_1: new CodeTextEnum('1', 'enum_1', '下請完了書類登録中'),
  enum_2: new CodeTextEnum('2', 'enum_2', '下請完了書類承認待ち'),
  enum_3: new CodeTextEnum('3', 'enum_3', '下請完了書類済'),
  enum_4: new CodeTextEnum('4', 'enum_4', '下請完了書類保留中'),
  enum_5: new CodeTextEnum('5', 'enum_5', '承認待ちあり'),
})
// タイル部斫り採取調査内容備考
const asbestosRemark1Enum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '機器損料、復旧含む'),
})
// 検体採取・分析調査内容備考
const asbestosRemark2Enum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', 'JIS A 1481-1に基づく'),
  enum_2: new CodeTextEnum('2', 'enum_2', 'JIS A 1481-3に基づく'),
  enum_3: new CodeTextEnum('3', 'enum_3', 'JIS A 1481-5に基づく'),
  enum_4: new CodeTextEnum('4', 'enum_4', 'JIS A 1481-1及び5に基づく'),
})
// 送信日付
const mailTimeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '本日から 3日後'),
  enum_2: new CodeTextEnum('2', 'enum_2', '本日から 6日後'),
  enum_3: new CodeTextEnum('3', 'enum_3', '本日から 12日後'),
})
// 提案計画へ反映
const proposalApplyEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '反映しない'),
  enum_1: new CodeTextEnum('1', 'enum_1', '反映する'),
})
// 建物管理形態
const manageFormEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '住込'),
  enum_2: new CodeTextEnum('2', 'enum_2', '通勤'),
  enum_3: new CodeTextEnum('3', 'enum_3', '巡回'),
  enum_4: new CodeTextEnum('4', 'enum_4', '常駐'),
  enum_5: new CodeTextEnum('5', 'enum_5', '非常駐'),
  enum_6: new CodeTextEnum('6', 'enum_6', 'フロントキーパー'),
  enum_7: new CodeTextEnum('7', 'enum_7', '巡回清掃管理員'),
  enum_8: new CodeTextEnum('8', 'enum_8', 'ＳＦＭ'),
  enum_9: new CodeTextEnum('9', 'enum_9', 'その他'),
})
// 納期区分2
const limitClass2Enum = Object.freeze({
  enum_A: new CodeTextEnum('A', 'enum_A', '開始日～終了日'),
  enum_B: new CodeTextEnum('B', 'enum_B', '契約の日から3ヶ月'),
  enum_C: new CodeTextEnum('C', 'enum_C', '契約の日から6ヶ月'),
  enum_D: new CodeTextEnum('D', 'enum_D', '契約の日から1年'),
  enum_Z: new CodeTextEnum('Z', 'enum_Z', 'その他(任意)'),
})
// 建物管理状態区分
const bulidingManageStatusEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '登録中'),
  enum_2: new CodeTextEnum('2', 'enum_2', '有効'),
  enum_3: new CodeTextEnum('3', 'enum_3', '変更中'),
  enum_8: new CodeTextEnum('8', 'enum_8', '取消'),
  enum_9: new CodeTextEnum('9', 'enum_9', '終了'),
})
// 発生元区分
const originClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '新規データ'),
  enum_2: new CodeTextEnum('2', 'enum_2', '改定データ'),
  enum_3: new CodeTextEnum('3', 'enum_3', '移行データ'),
})
// ｃｌ請負フラグ
const clContractFlagEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '元請'),
  enum_2: new CodeTextEnum('2', 'enum_2', '非元請'),
})
// 印刷状況
const printStsEnum = Object.freeze({
  enum_10: new CodeTextEnum('10', 'enum_10', '印刷データ転送完了'),
  enum_20: new CodeTextEnum('20', 'enum_20', '印刷開始'),
  enum_30: new CodeTextEnum('30', 'enum_30', '印刷中'),
  enum_40: new CodeTextEnum('40', 'enum_40', '印刷成功'),
  enum_50: new CodeTextEnum('50', 'enum_50', '印刷失敗'),
})
// ダウンロード状況
const dlStsEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '未ダウンロード　'),
  enum_1: new CodeTextEnum('1', 'enum_1', 'ダウンロード済'),
})
// 依頼区分
const requestClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '事前調査'),
  enum_2: new CodeTextEnum('2', 'enum_2', '工事・作業'),
})
// 日程調整状況
const adjScheduleStatusEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '未提出'),
  enum_2: new CodeTextEnum('2', 'enum_2', '提出済み'),
  enum_3: new CodeTextEnum('3', 'enum_3', '催促中'),
  enum_4: new CodeTextEnum('4', 'enum_4', '調整済み'),
  enum_5: new CodeTextEnum('5', 'enum_5', '差し戻し'),
  enum_6: new CodeTextEnum('6', 'enum_6', '再調整'),
})
// 書類提出状況
const docSubmitStatusEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '未提出'),
  enum_2: new CodeTextEnum('2', 'enum_2', '提出済み'),
  enum_3: new CodeTextEnum('3', 'enum_3', '催促中'),
  enum_4: new CodeTextEnum('4', 'enum_4', '確認済み'),
  enum_5: new CodeTextEnum('5', 'enum_5', '差し戻し'),
  enum_6: new CodeTextEnum('6', 'enum_6', '確認済み（更新あり）'),
  enum_7: new CodeTextEnum('7', 'enum_7', '確認済み（移動済み）'),
  enum_8: new CodeTextEnum('8', 'enum_8', '確認済み（削除済み）'),
})
// 現地調整確認フラグ
const localAdjFlgEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '未実施'),
  enum_1: new CodeTextEnum('1', 'enum_1', '確認済み'),
})
// 消防協議実施フラグ
const fireConsultationFlgEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '未実施'),
  enum_1: new CodeTextEnum('1', 'enum_1', '実施済み'),
})
// 選定フラグ
const selectFlgEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '未選定'),
  enum_1: new CodeTextEnum('1', 'enum_1', '選定'),
})
// 着工広報ステータス
const startPosterStatusEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '起案中'),
  enum_2: new CodeTextEnum('2', 'enum_2', '工事計画担当者処理中'),
  enum_3: new CodeTextEnum('3', 'enum_3', '工事担当確認中'),
  enum_4: new CodeTextEnum('4', 'enum_4', 'LC処理中'),
  enum_5: new CodeTextEnum('5', 'enum_5', '庶務確認中'),
  enum_6: new CodeTextEnum('6', 'enum_6', 'PS課処理中'),
  enum_7: new CodeTextEnum('7', 'enum_7', '完了'),
})
// 工事分類ｃｄ
const constructClassCdEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '大規模'),
  enum_2: new CodeTextEnum('2', 'enum_2', '塗装（鉄部）'),
  enum_3: new CodeTextEnum('3', 'enum_3', '立駐塗装'),
  enum_4: new CodeTextEnum('4', 'enum_4', '立駐埋戻し'),
  enum_5: new CodeTextEnum('5', 'enum_5', '管（増圧、ライニング、管更新など）'),
  enum_6: new CodeTextEnum('6', 'enum_6', 'インターホン'),
  enum_7: new CodeTextEnum('7', 'enum_7', 'それ以外'),
  enum_8: new CodeTextEnum(
    '8',
    'enum_8',
    'エレベーター更新、機械駐入替等（機械器具設置）'
  ),
})
// 実施可能区分
const implementClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '不可能'),
  enum_2: new CodeTextEnum('2', 'enum_2', '可能であるが、できれば工期外を希望'),
  enum_3: new CodeTextEnum('3', 'enum_3', '可能'),
})
// 実施可能参考
const implementRefEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '◎　'),
  enum_21: new CodeTextEnum('21', 'enum_21', '○'),
  enum_22: new CodeTextEnum(
    '22',
    'enum_22',
    '○（特建がある場合は×・雑排同日実施の場合は要拠点判断）　'
  ),
  enum_23: new CodeTextEnum(
    '23',
    'enum_23',
    '○（雑排同日実施の場合は要拠点判断）'
  ),
  enum_31: new CodeTextEnum('31', 'enum_31', '△'),
  enum_32: new CodeTextEnum('32', 'enum_32', '△（内容要確認の上判断）　'),
  enum_33: new CodeTextEnum(
    '33',
    'enum_33',
    '△（調整時は品質管理チームに相談）　'
  ),
  enum_34: new CodeTextEnum(
    '34',
    'enum_34',
    '△（避難ハッチなどが点検できるかで判断・雑排同日実施の場合は要拠点判断）'
  ),
  enum_41: new CodeTextEnum('41', 'enum_41', '×'),
  enum_42: new CodeTextEnum('42', 'enum_42', '×（同日もの要確認）　'),
  enum_43: new CodeTextEnum(
    '43',
    'enum_43',
    '×（清掃日の指定がコメントで日曜限定など、工事日に関係ない場合は実施可。同日もの要確認）'
  ),
  enum_44: new CodeTextEnum(
    '44',
    'enum_44',
    '×（雑排同日実施の場合は要拠点判断）'
  ),
})
// 実施の判断
const implementJudgeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '中止'),
  enum_2: new CodeTextEnum('2', 'enum_2', '工期前実施希望'),
  enum_3: new CodeTextEnum('3', 'enum_3', '工期後実施希望'),
  enum_4: new CodeTextEnum('4', 'enum_4', '予定通り実施'),
})
// 実施月
const implementMonthEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '当初設定月中を希望'),
  enum_2: new CodeTextEnum('2', 'enum_2', '設定月外でも可能'),
})
// 同日実施
const samedayImplementEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '一緒にずらす'),
  enum_2: new CodeTextEnum('2', 'enum_2', 'ずらさない'),
})
// 点検実施範囲
const inspecteScopeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '変更無し'),
  enum_2: new CodeTextEnum('2', 'enum_2', '範囲を縮小または変更して実施'),
})
// 可能日依頼状況
const requestStatusEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '未提出 '),
  enum_2: new CodeTextEnum('2', 'enum_2', '催促中'),
  enum_3: new CodeTextEnum('3', 'enum_3', '提出済み'),
})
// 依頼有無
const requestExistEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '未依頼'),
  enum_1: new CodeTextEnum('1', 'enum_1', '依頼済み'),
})
// イベント区分
const eventClassEnum = Object.freeze({
  enum_01: new CodeTextEnum('01', 'enum_01', '日程調整'),
})
// 調整元区分
const adjSourceClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '協力会社'),
  enum_2: new CodeTextEnum('2', 'enum_2', 'DLN'),
})
// 調査要否
const investigationFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '要'),
  enum_0: new CodeTextEnum('0', 'enum_0', '不要'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '未指定'),
})
// 依頼対応区分
const dealingFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '日程調整要'),
  enum_0: new CodeTextEnum('0', 'enum_0', '日程調整不要'),
  enum_2: new CodeTextEnum('2', 'enum_2', '対応不可'),
})
// 提出確認区分
const docConfirmFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '提出'),
  enum_2: new CodeTextEnum('2', 'enum_2', '確認（連携不要）'),
  enum_3: new CodeTextEnum('3', 'enum_3', '確認（連携要）'),
  enum_0: new CodeTextEnum('0', 'enum_0', '連携（協力会社）'),
  enum_4: new CodeTextEnum('4', 'enum_4', '連携（社内）'),
})
// 指定区分
const specifyFlgEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '指定なし'),
  enum_1: new CodeTextEnum('1', 'enum_1', '限定'),
  enum_2: new CodeTextEnum('2', 'enum_2', '不可'),
})
// 日付指定範囲
const dateSpecifyRangeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '月初（1日～5日）'),
  enum_2: new CodeTextEnum('2', 'enum_2', '月末（25日～月末）'),
  enum_3: new CodeTextEnum('3', 'enum_3', '上旬（1日～10日）'),
  enum_4: new CodeTextEnum('4', 'enum_4', '中旬（11日～20日）'),
  enum_5: new CodeTextEnum('5', 'enum_5', '下旬（21日～月末）'),
  enum_6: new CodeTextEnum('6', 'enum_6', '前半（1日～15日）'),
  enum_7: new CodeTextEnum('7', 'enum_7', '後半（16日～月末）'),
})
// 時間指定条件
const timeSpecifyConditionEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '開始時間を指定'),
  enum_2: new CodeTextEnum('2', 'enum_2', '終了時間を指定'),
  enum_3: new CodeTextEnum('3', 'enum_3', '時間範囲を指定'),
  enum_4: new CodeTextEnum('4', 'enum_4', '午前指定'),
  enum_5: new CodeTextEnum('5', 'enum_5', '午後指定'),
})
// お知らせ文期日単位
const notifyLimitUnitEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', 'ヶ月前'),
  enum_2: new CodeTextEnum('2', 'enum_2', '週間前'),
})
// お知らせ文宛先
const notifyDestinationEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '管理事務室'),
  enum_2: new CodeTextEnum('2', 'enum_2', '担当支店'),
})
// 報告書宛先
const reportDestinationEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', 'パートナーサポート課'),
  enum_2: new CodeTextEnum('2', 'enum_2', '担当支店'),
})
// 報告書配送
const reportShipFlagEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '必着'),
  enum_2: new CodeTextEnum('2', 'enum_2', '配送'),
})
// グループ
const groupValueEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '0次'),
  enum_2: new CodeTextEnum('2', 'enum_2', '0.5次'),
  enum_3: new CodeTextEnum('3', 'enum_3', '1次'),
  enum_4: new CodeTextEnum('4', 'enum_4', '2次'),
})
// 同日可否フラグ
const sameDayFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '必須'),
  enum_2: new CodeTextEnum('2', 'enum_2', '不可'),
})
// 宛先役割区分
const mailRolesFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '依頼者'),
  enum_2: new CodeTextEnum('2', 'enum_2', '進行担当者'),
  enum_3: new CodeTextEnum('3', 'enum_3', 'LC'),
  enum_4: new CodeTextEnum('4', 'enum_4', 'FM'),
})
// 作業予実調整ステータス
const wparStatusEnum = Object.freeze({
  enum_01: new CodeTextEnum('01', 'enum_01', '発注予定'),
  enum_02: new CodeTextEnum('02', 'enum_02', '入力待ち'),
  enum_03: new CodeTextEnum('03', 'enum_03', '催促要'),
  enum_04: new CodeTextEnum('04', 'enum_04', '催促中'),
  enum_05: new CodeTextEnum('05', 'enum_05', '入力済み'),
  enum_06: new CodeTextEnum('06', 'enum_06', '日程要変更'),
  enum_07: new CodeTextEnum('07', 'enum_07', '確認待ち'),
  enum_08: new CodeTextEnum('08', 'enum_08', '確認済み'),
  enum_09: new CodeTextEnum('09', 'enum_09', '連絡中'),
  enum_blank: new CodeTextEnum('  ', 'enum_blank', 'N/A'),
})
// チェック結果
const checkResultEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', 'OK'),
  enum_0: new CodeTextEnum('0', 'enum_0', 'NG'),
})
// 作業予実変更依頼フラグ
const changeRequestFlgEnum = Object.freeze({
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '未依頼'),
  enum_1: new CodeTextEnum('1', 'enum_1', 'DLNプッシュ'),
  enum_2: new CodeTextEnum('2', 'enum_2', 'DLN変更依頼'),
  enum_3: new CodeTextEnum('3', 'enum_3', '協力会社変更依頼'),
  enum_4: new CodeTextEnum('4', 'enum_4', '差し戻し'),
  enum_8: new CodeTextEnum('8', 'enum_8', '依頼取消'),
  enum_9: new CodeTextEnum('9', 'enum_9', '依頼済み'),
})
// 作業予実変更項目
const changeCategoryEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '変更'),
  enum_1: new CodeTextEnum('1', 'enum_1', '月変更'),
  enum_2: new CodeTextEnum('2', 'enum_2', '追加'),
  enum_3: new CodeTextEnum('3', 'enum_3', '連絡'),
  enum_4: new CodeTextEnum('4', 'enum_4', '中止'),
})
// 現地確認フラグ（不要つもり）
const localComfirmFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '現地確認要'),
  enum_2: new CodeTextEnum('2', 'enum_2', '現地確認済み'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', 'N/A'),
})
// 実施日入力状況
const resultDateInputStatusEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '未入力'),
  enum_1: new CodeTextEnum('1', 'enum_1', '催促中'),
  enum_2: new CodeTextEnum('2', 'enum_2', '入力済み'),
})
// 変更フラグ
const changeFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '追加'),
  enum_2: new CodeTextEnum('2', 'enum_2', '変更'),
  enum_3: new CodeTextEnum('3', 'enum_3', '中止'),
  enum_blank: new CodeTextEnum(' ', 'enum_blank', 'N/A'),
})
// 報告書状況
const reportStatusEnum = Object.freeze({
  enum_00: new CodeTextEnum('00', 'enum_00', '未提出'),
  enum_01: new CodeTextEnum('01', 'enum_01', '協力会社へ催促中'),
  enum_02: new CodeTextEnum('02', 'enum_02', '提出済み'),
  enum_03: new CodeTextEnum('03', 'enum_03', 'PS課確認済み'),
  enum_04: new CodeTextEnum('04', 'enum_04', '管理部差し戻し'),
  enum_05: new CodeTextEnum('05', 'enum_05', '管理部確認済み'),
  enum_10: new CodeTextEnum('10', 'enum_10', 'LCへ催促中'),
  enum_11: new CodeTextEnum('11', 'enum_11', 'LC確認済み（組合確認済み）'),
  enum_15: new CodeTextEnum('15', 'enum_15', '行政提出済み'),
  enum_16: new CodeTextEnum('16', 'enum_16', '副本受領済み'),
  enum_20: new CodeTextEnum('20', 'enum_20', '確認完了'),
  enum_21: new CodeTextEnum('21', 'enum_21', '確認済み（移動済み）'),
  enum_22: new CodeTextEnum('22', 'enum_22', '確認済み（削除済み）'),
})
// 対応状況
const responseStatusEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '入力中'),
  enum_2: new CodeTextEnum('2', 'enum_2', '登録完了（不具合あり）'),
  enum_3: new CodeTextEnum('3', 'enum_3', '登録完了（不具合なし）'),
})
// 点検結果
const inspectionStatusEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '前回同様'),
  enum_1: new CodeTextEnum('1', 'enum_1', '改修済み'),
  enum_2: new CodeTextEnum('2', 'enum_2', '確認不可能'),
  enum_3: new CodeTextEnum('3', 'enum_3', '今回発生不具合'),
})
// 未実施区分
const unimplementClassEnum = Object.freeze({
  enum_00: new CodeTextEnum('00', 'enum_00', 'N/A'),
  enum_01: new CodeTextEnum('01', 'enum_01', '不在'),
  enum_02: new CodeTextEnum('02', 'enum_02', '辞退'),
  enum_03: new CodeTextEnum('03', 'enum_03', '空室'),
})
// 報告書形式
const reportFormatEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '速報版＋正式版'),
  enum_2: new CodeTextEnum('2', 'enum_2', '速報版＝正式版'),
  enum_3: new CodeTextEnum('3', 'enum_3', '報告書不要'),
})
// 報告書種類フラグ
const reportTypeFlagEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '速報'),
  enum_1: new CodeTextEnum('1', 'enum_1', '正式'),
  enum_2: new CodeTextEnum('2', 'enum_2', '原価見積書'),
  enum_9: new CodeTextEnum('9', 'enum_9', 'その他'),
})
// 不具合管理フラグ
const defectFlagEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '不具合情報'),
  enum_2: new CodeTextEnum('2', 'enum_2', '不具合情報＋住戸登録'),
  enum_3: new CodeTextEnum('3', 'enum_3', '不具合情報＋総合設備点検'),
  enum_4: new CodeTextEnum('4', 'enum_4', '不具合不要'),
})
// 正式版確認区分
const officalConfrimClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', 'PS課'),
  enum_2: new CodeTextEnum('2', 'enum_2', 'PS課＆管理部'),
  enum_3: new CodeTextEnum('3', 'enum_3', '管理部'),
  enum_4: new CodeTextEnum('4', 'enum_4', '法定'),
})
// 進捗対象区分
const progessTargetClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', 'EV'),
  enum_2: new CodeTextEnum('2', 'enum_2', '建築'),
  enum_3: new CodeTextEnum('3', 'enum_3', '植栽'),
  enum_4: new CodeTextEnum('4', 'enum_4', '清掃'),
  enum_5: new CodeTextEnum('5', 'enum_5', '消防'),
  enum_6: new CodeTextEnum('6', 'enum_6', 'その他'),
})
// 指摘有無
const indicateFlagEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '指摘無し'),
  enum_1: new CodeTextEnum('1', 'enum_1', '指摘あり'),
})
// 検索区分
const queryClassEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '商品明細別パターン'),
  enum_2: new CodeTextEnum('2', 'enum_2', '作業仕様別パターン'),
  enum_3: new CodeTextEnum('3', 'enum_3', '商品明細別テンプレート'),
})
// プッシュ区分
const pushTypeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '未入力'),
  enum_2: new CodeTextEnum('2', 'enum_2', '不可日'),
})
// 既読フラグ
const readFlgEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '未読'),
  enum_1: new CodeTextEnum('1', 'enum_1', '既読'),
})
// 北関返送状況
const northSendStatusEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '未返送'),
  enum_2: new CodeTextEnum('2', 'enum_2', '返送済み'),
})
// 断水仕様区分
const waterOutageTypeEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '断水有'),
  enum_2: new CodeTextEnum('2', 'enum_2', '断水不可'),
})
// 同日可否フラグ
const samedayFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '必須'),
  enum_2: new CodeTextEnum('2', 'enum_2', '不可'),
})
// 作成元区分
const workOriginClassEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', 'clombs'),
  enum_1: new CodeTextEnum('1', 'enum_1', 'order'),
})
// 写真受取区分
const photoReceiveFlagEnum = Object.freeze({
  enum_blank: new CodeTextEnum(' ', 'enum_blank', '未取得'),
  enum_1: new CodeTextEnum('1', 'enum_1', '取得済み'),
})
// 削除もの含む
const deletedContainFlagEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '削除済データを含まない'),
  enum_1: new CodeTextEnum('1', 'enum_1', '削除済データを含む'),
})
// 調整不要もの含む
const adjustedContainFlagEnum = Object.freeze({
  enum_0: new CodeTextEnum('0', 'enum_0', '日程調整不要を含まない  '),
  enum_1: new CodeTextEnum('1', 'enum_1', '日程調整不要を含む'),
})
// 管理部門
const manageDeptEnum = Object.freeze({
  enum_E: new CodeTextEnum('E', 'enum_E', 'パートナーサポート課(東日本)'),
  enum_W: new CodeTextEnum('W', 'enum_W', 'パートナーサポート課(西日本)'),
})
// 様式
const formStyleEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '総合設備データリスト'),
  enum_2: new CodeTextEnum('2', 'enum_2', '総合設備点検不具合詳細'),
})
// 点検可否区分
const checkableFlgEnum = Object.freeze({
  enum_1: new CodeTextEnum('1', 'enum_1', '点検可'),
  enum_0: new CodeTextEnum('0', 'enum_0', '点検不可'),
})
// 建物管理形態
const bulidingManageFormEnum = Object.freeze({
  enum_2: new CodeTextEnum('2', 'enum_2', '通勤'),
  enum_0: new CodeTextEnum('0', 'enum_0', '通勤以外'),
})
module.exports = {
  //提案計画進捗状態
  proposalProgressStatusEnum,
  //見積ステータス
  estimateStatusEnum,
  //受注状態区分
  acceptOrderStatusClassEnum,
  //受注ステータス
  acceptOrderStatusEnum,
  //発注ステータス
  purchaseOrderStatusEnum,
  //請求書敬称区分
  billTitleClassEnum,
  //提案対応レベル
  demandResponseLevelEnum,
  //取引先区分
  customerClassEnum,
  //請求書出力区分(受注)
  acceptOrderInvoiceOutputClassEnum,
  //請求支払区分
  billPayClassEnum,
  //分類
  classificationEnum,
  //拠点区分
  baseClassEnum,
  //引当完了区分
  depositFinishClassEnum,
  //工期区分
  constructionClassEnum,
  //作成判断区分
  createJudgeClassEnum,
  //作成状態フラグ
  createStateFlgEnum,
  //工事内容区分
  workDetailClassEnum,
  //預金種別
  depositTypeEnum,
  //納期区分
  limitClassEnum,
  //採用区分
  adoptFlagEnum,
  //見積レベル
  estimateLevelEnum,
  //見積無区分
  noEstimateFlgEnum,
  //見積書様式区分
  estimateStyleClassEnum,
  //設備分類
  facilityClassEnum,
  //発注書出力区分
  purchaseOrderOutputClassEnum,
  //発生元識別区分
  originIdentClassEnum,
  //産廃取扱い区分
  industryTrashHandlingFlgEnum,
  //お知らせ区分
  infoClassEnum,
  //業務形態
  consignmentWorkClassEnum,
  //受注区分ｃｄ
  acceptOrderClassCdEnum,
  //ｋｅｙ種別
  keyClassEnum,
  //金額ゼロ種別
  priceZeroClassEnum,
  //内外区分
  inOutClassEnum,
  //要否区分
  necessaryFlagEnum,
  //不要フラグ
  unnecessaryFlagEnum,
  //真偽区分
  boolFlagEnum,
  //有無区分
  existFlagEnum,
  //有無区分2
  existFlag2Enum,
  //発注作成区分
  generationClassEnum,
  //納品後請求フラグ
  afterDeliveryBillFlgEnum,
  //印鑑区分
  stampClassEnum,
  //消費税計算区分
  consumptionTaxCalClassEnum,
  //発注期間区分
  periodClassEnum,
  //作業予実区分
  planAndResultClassEnum,
  //支払条件
  payConditionEnum,
  //工事記録簿ｽﾃｰﾀｽ(基本)
  constructionRecordStatusBaseEnum,
  //工事記録簿ｽﾃｰﾀｽ(受注締結)
  constructionRecordStatusAcceptingOrderAlliaEnum,
  //工事記録簿ｽﾃｰﾀｽ(組合完了確認書)
  constructionRecordStatusUniFinishAckEnum,
  //工事記録簿ｽﾃｰﾀｽ(完了報告書)
  constructionRecordStatusFinishReportEnum,
  //工事記録簿ｽﾃｰﾀｽ(下請締結)
  constructionRecordStatusSubconAlliaEnum,
  //工事記録簿ｽﾃｰﾀｽ(下請完了)
  constructionRecordStatusSubconFinishEnum,
  //発注保証書区分
  purchaseOrderWarrantyClassEnum,
  //工事記録簿ステータス（受注）
  constructionRecordStatusAcceptingOrderEnum,
  //工事記録簿ステータス（発注）
  constructionRecordStatusPurchaseOrderEnum,
  //案件タイプ
  demandTypeEnum,
  //印刷住所ｆ
  printAddressFlgEnum,
  //被請求書発行フラグ
  printFlgEnum,
  //案件状況
  demandPhaseEnum,
  //実施周期
  implementationCycleEnum,
  //未採用フラグ
  unAdoptedFlgEnum,
  //取消フラグ
  cancelFlgEnum,
  //非課税フラグ
  noTaxFlgEnum,
  //完了フラグ
  finishFlgEnum,
  //注文印刷住所フラグ
  printAdrsFlgEnum,
  //１円調整フラグ
  adj1yenFlgEnum,
  //緊急対応フラグ
  emergencySupportFlgEnum,
  //石綿対応
  asbestoContainFlgEnum,
  //ｅｃｏ文書フラグ
  ecoDocFlgEnum,
  //連携フラグ
  alignFlgEnum,
  //出力区分
  outputFlgEnum,
  //承認動作
  actionEnum,
  //プロセスインスタンスステータス
  procInstStatusEnum,
  //見積承認タイプ
  estimateTypeEnum,
  //請求予定月フラグ
  billPlanMonthFlgEnum,
  //入金予定月ｃｄ
  depositPlanMonthCdEnum,
  //請求出力方法
  billOutputClassEnum,
  //ｍｓ会計取得済フラグ
  msAccountAcquiredFlagEnum,
  //受託作業区分
  entrustedWorkFlagEnum,
  //採番区分
  sequenceDivisionEnum,
  //有効フラグ
  validFlgEnum,
  //無効フラグ
  invalidFlgEnum,
  //終了もの含む
  finishedContainFlagEnum,
  //権限タイプ
  permissionTypeEnum,
  //提案計画反映フラグ
  proposalApplyFlgEnum,
  //勤務仕様
  knmmcdEnum,
  //祝日フラグ
  hldfEnum,
  //排水制限
  drainageLimitEnum,
  //産廃処理区分
  trashTreatDivisionEnum,
  //作成状態フラグ
  crtstsfEnum,
  //見積値引区分
  estimateDiscountTypeEnum,
  //エスカレーション承認区分
  escalationApprovalClassEnum,
  //原価ゼロ発注ｃフラグ
  costZeroFlgEnum,
  //産業廃棄物
  industryTrashFlgEnum,
  //専任有無区分
  fullTimeClassEnum,
  //主任監理区分
  chiefSuperClassEnum,
  //工事記録簿受注拒否アクション
  constructionRecordAcceptOrderDenyActionEnum,
  //工事記録簿発注拒否アクション
  constructionRecordOrderDenyActionEnum,
  //不可フラグ
  canNotFlgEnum,
  //可否区分
  canFlgEnum,
  //計上部門区分
  accountingDepClassEnum,
  //納品完了ステータス
  deliveryFinishStatusEnum,
  //一時ファイル区分
  tempFileTypeEnum,
  //工事役務区分
  workServiceClassEnum,
  //工事記録簿発注承認タイプ
  constructionRecordPurOrderTypeEnum,
  //工事記録簿承認タイプ
  constructionRecordBaseTypeEnum,
  //調査入力済フラグ
  surveyEnteredFlagEnum,
  //担当区分
  chargeRoleEnum,
  //担当種別
  chargeTypeEnum,
  //書類区分
  docClassEnum,
  //テンプレートcd
  mailTemplateCdEnum,
  //必須フラグ
  requiredFlgEnum,
  //未決フラグ
  decidedFlagEnum,
  //書類到着フラグ
  documentArrivalFlgEnum,
  //操作タイプ
  operationTypeEnum,
  //管理終了ｆ
  mngendfEnum,
  //受取フラグ
  receiptFlgEnum,
  //確認フラグ
  confirmFlgEnum,
  //承認クラスｃｄ
  autclscdEnum,
  //工事記録簿登録モード
  constructionRecordApprovalModeEnum,
  //納品完了区分
  deliveryCompleteEnum,
  //納品完了ステー
  deliveryCompleteStatusEnum,
  //見積アクションモード
  estimateActionModeEnum,
  //見積フロータイプ
  estimateFlowTypeEnum,
  //発注入力モード
  purchaseOrderEntryModeEnum,
  //ステータス下請締結
  subcontractStatusSumEnum,
  //ステータス下請完了
  completedSubcontractStatusSumEnum,
  //タイル部斫り採取調査内容備考
  asbestosRemark1Enum,
  //検体採取・分析調査内容備考
  asbestosRemark2Enum,
  //送信日付
  mailTimeEnum,
  //提案計画へ反映
  proposalApplyEnum,
  //建物管理形態
  manageFormEnum,
  //納期区分2
  limitClass2Enum,
  //建物管理状態区分
  bulidingManageStatusEnum,
  //発生元区分
  originClassEnum,
  //ｃｌ請負フラグ
  clContractFlagEnum,
  //印刷状況
  printStsEnum,
  //ダウンロード状況
  dlStsEnum,
  //依頼区分
  requestClassEnum,
  //日程調整状況
  adjScheduleStatusEnum,
  //書類提出状況
  docSubmitStatusEnum,
  //現地調整確認フラグ
  localAdjFlgEnum,
  //消防協議実施フラグ
  fireConsultationFlgEnum,
  //選定フラグ
  selectFlgEnum,
  //着工広報ステータス
  startPosterStatusEnum,
  //工事分類ｃｄ
  constructClassCdEnum,
  //実施可能区分
  implementClassEnum,
  //実施可能参考
  implementRefEnum,
  //実施の判断
  implementJudgeEnum,
  //実施月
  implementMonthEnum,
  //同日実施
  samedayImplementEnum,
  //点検実施範囲
  inspecteScopeEnum,
  //可能日依頼状況
  requestStatusEnum,
  //依頼有無
  requestExistEnum,
  //イベント区分
  eventClassEnum,
  //調整元区分
  adjSourceClassEnum,
  //調査要否
  investigationFlgEnum,
  //依頼対応区分
  dealingFlgEnum,
  //提出確認区分
  docConfirmFlgEnum,
  //指定区分
  specifyFlgEnum,
  //日付指定範囲
  dateSpecifyRangeEnum,
  //時間指定条件
  timeSpecifyConditionEnum,
  //お知らせ文期日単位
  notifyLimitUnitEnum,
  //お知らせ文宛先
  notifyDestinationEnum,
  //報告書宛先
  reportDestinationEnum,
  //報告書配送
  reportShipFlagEnum,
  //グループ
  groupValueEnum,
  //同日可否フラグ
  sameDayFlgEnum,
  //宛先役割区分
  mailRolesFlgEnum,
  //作業予実調整ステータス
  wparStatusEnum,
  //チェック結果
  checkResultEnum,
  //作業予実変更依頼フラグ
  changeRequestFlgEnum,
  //作業予実変更項目
  changeCategoryEnum,
  //現地確認フラグ（不要つもり）
  localComfirmFlgEnum,
  //実施日入力状況
  resultDateInputStatusEnum,
  //変更フラグ
  changeFlgEnum,
  //報告書状況
  reportStatusEnum,
  //対応状況
  responseStatusEnum,
  //点検結果
  inspectionStatusEnum,
  //未実施区分
  unimplementClassEnum,
  //報告書形式
  reportFormatEnum,
  //報告書種類フラグ
  reportTypeFlagEnum,
  //不具合管理フラグ
  defectFlagEnum,
  //正式版確認区分
  officalConfrimClassEnum,
  //進捗対象区分
  progessTargetClassEnum,
  //指摘有無
  indicateFlagEnum,
  //検索区分
  queryClassEnum,
  //プッシュ区分
  pushTypeEnum,
  //既読フラグ
  readFlgEnum,
  //北関返送状況
  northSendStatusEnum,
  //断水仕様区分
  waterOutageTypeEnum,
  //同日可否フラグ
  samedayFlgEnum,
  //作成元区分
  workOriginClassEnum,
  //写真受取区分
  photoReceiveFlagEnum,
  //削除もの含む
  deletedContainFlagEnum,
  //調整不要もの含む
  adjustedContainFlagEnum,
  //管理部門
  manageDeptEnum,
  //様式
  formStyleEnum,
  //点検可否区分
  checkableFlgEnum,
  //建物管理形態
  bulidingManageFormEnum,
}
